<script>
import axios from "axios";
import currencyCommons from "../mixins/currencyCommons.vue";
import shopCommons from "@/features/shared/mixins/shopCommons.vue";
import { parseToQuery } from "../utils/utils";
import { buildSyncProductsWithFdsPayload } from "@/features/shared/utils/menuChangesClassifier";
import {
  getFdsNameBySourceId,
  normalizeFdsOriginName,
} from "@/features/shared/utils/fdsOrigins";
import { useIntegrationComposable } from "@/features/integrations/composables/useIntegrationComposable";
import bOrdersCommons from "../mixins/bOrdersCommons";
import instanceCommons from "@/mixins/instanceCommons.vue";
import authCommons from "../mixins/authCommons";
import originCommons from "../mixins/originCommons.vue";
import rolesCommons from "../mixins/rolesCommons.vue";
import validateCommons from "@/features/shared/mixins/validateCommons.vue";
import QrGenerator from "../mixins/QrGenerator";
import centralizedProductsCommons from "@/mixins/centralizedProductsCommons.vue";
import { toast } from "vue3-toastify";
import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";

import { db } from "../firebase.js";
import { ref, get, update, push, set, remove, off } from "firebase/database";
import { firebaseCache } from "@/services/FirebaseCache.js";

export default {
  /* eslint-disable */
  mixins: [
    authCommons,
    bOrdersCommons,
    centralizedProductsCommons,
    QrGenerator,
    currencyCommons,
    shopCommons,
    instanceCommons,
    originCommons,
    rolesCommons,
    validateCommons,
  ],
  data() {
    return {
      // BPM-26: canales FDS que el comercio tiene integrados hoy. null = no se
      // pudo averiguar, y en ese caso no se filtra ningún badge de sync.
      enabledFdsSlugs: null,
      currentProduct: null,
      currentCombo: null,
      objectToRemove: null,
      isNewProduct: false,
      isNewCombo: false,
      deletingCombo: false,
      deletingProduct: false,
      isNewIngredient: false,
      availableBackups: [],
      additionalOptionType: "Adicional",
      excelParams: "",
      excelAditionalParams: "",
      isNewOption: false,
      optionType: "",
      menues: [],
      origins: [],
      originsForUse: [],
      menu: {
        key: "",
        name: "",
        origins: [],
      },
      productsByMenu: [],
      isNewMenu: false,
      category: {
        name: "",
        optionsGroups: [],
      },
      isNewCategory: false,
      oldCategoryName: "",
      combos: [],
      ingredients: [],
      originalIngredients: [],
      filteredIngredients: [],
      optionGroups: [], // Contiene los nombres o identificadores de los grupos de opciones
      optionsByGroup: [], // Contiene las opciones asociadas a cada grupo
      ingredientsNoFilter: [],
      combosFromFirebase: [],
      checkedCategories: [],
      initialCheckedCategories: [],
      currentMenu: null,
      originsNodo: [],
      savingControl: false,
      deleteControl: 0,
      controlVariablex: false,
      onUpsertMenuNro: 0,
      // BS-6442: delta de disponibilidad del guardado en curso ({ turnOff: [sku] } o null).
      // Lo setea onUpsertMenu y lo consume (y limpia) finishUpsert.
      pendingAvailabilityOnly: null,
      parentShopCode: null,
      averageRatingList: [],
    };
  },
  computed: {
    getMenues() {
      return this.menues;
    },
    getCurrentSku() {
      if (this.currentProduct === null) {
        return "";
      }

      return this.currentProduct.sku;
    },
    getCurrentComboSku() {
      if (this.currentCombo === null) {
        return "";
      }

      return this.currentCombo.sku;
    },
    hasCentralizedProducts() {
      if (this.selectedList == null || this.selectedList == undefined)
        return false;
      const list = this.$store.getCentralizedProductsList;
      if (list === null || list === undefined) return false;
      if (list.length == 0) return false;
      var index = list.findIndex(
        (t) => t.shopCode === this.selectedList.shopCode
      );
      if (index == -1) return false;
      return list[index].hasCentralizedProducts;
    },
    canEditProductsCheck() {
      if (this.hasCentralizedProducts) {
        return this.canModifyCentralizedProducts;
      } else {
        return this.canEditProducts;
      }
    },

    getParentShopCode() {
      // Guardias: selectedList puede no estar inicializado aún al montar el componente
      if (!this.selectedList || !this.selectedList.shopCode) return undefined;
      const currentCode = this.selectedList.shopCode;
      const centralizedProductList = this.$store.getCentralizedProductsList;
      if (!Array.isArray(centralizedProductList) || centralizedProductList.length === 0) return undefined;

      const centralizedProductInfo = centralizedProductList.find((x) => x && x.shopCode === currentCode);
      if (!centralizedProductInfo) return undefined;

      if (centralizedProductInfo.canModifyCentralizedProducts) return centralizedProductInfo.shopCode;
      return centralizedProductInfo.parentShopCode;
    },
    canModifyCentralizedProducts() {
      if (
        this.$store.getAuthUser?.roles?.filter(
          (role) =>
            role.includes("ProductsAdministration") ||
            role.includes("Administrador")
        ).length == 0
      )
        return false;
      if (this.selectedList == null || this.selectedList == undefined)
        return false;
      const list = this.$store.getCentralizedProductsList;
      if (list === null || list === undefined) return false;
      if (list.length == 0) return false;
      var index = list.findIndex(
        (t) => t.shopCode === this.selectedList.shopCode
      );
      if (index == -1) return false;
      return list[index].canModifyCentralizedProducts;
    },
    hasCentralizedStockEnabled(){
      if (this.selectedList == null || this.selectedList == undefined)
              return false;
            const list = this.$store.getCentralizedProductsList;
            if (list === null || list === undefined) return false;
            if (list.length == 0) return false;
            var index = list.findIndex(
              (t) => t.shopCode === this.selectedList.shopCode
            );
            if (index == -1) return false;
            return list[index].hasUnifiedStock;
    },    
  },
  methods: {
    buildMenuPublicUrl(shopCode, menuUUID, subdomain) {
      const parentCommerceId = this.resolveShopCodeForProductsList(shopCode);
      const baseUrl = `https://${subdomain}.bistrosoft.com/menu?commerceId=${shopCode}&menuUUID=${menuUUID}`;
      return parentCommerceId != shopCode
        ? `${baseUrl}&parentCommerceId=${parentCommerceId}`
        : baseUrl;
    },
    getProductsInUse(products) {
      let array = [];
      products.forEach((p) => {
        if (p.currentPrice !== "") {
          array.push(p);
        }
      });
      return array;
    },
    async getContextFromBackendForProducts() {
      if (!navigator.onLine) return;
      this.$store.initLoading(this);
      const res = await axios
        .get(`/api/productsV2/getContextFromBackendForProducts`)
        .catch(() => {
          this.$store.errorLoading(this);
        });

      this.$store.finishLoading(this);

      if (res.data.responseCode == 0) {
        this.$store.loadBackendContext(res.data);
      } else {
        console.error(res.data.responseMessage);
      }
    },

    async getTokuLinks() {
      this.$store.initLoading(this);

      var res = await axios.get(`/api/productsV2/getTokuLinks`).catch(() => {
        this.$store.errorLoading(this);
      });
      this.$store.finishLoading(this);

      if (res.data.responseCode == 0) {
        return res.data.listTokuUrls;
      } else {
        console.error(res.data.responseMessage);
      }
      return null;
    },

    async loadOrigins() {
      const refDataOrigins = ref(db, "origins");
      const snapshot = await get(refDataOrigins)
      this.originsNodo = snapshot.val();
    },
    async onGenerateBarcode(menu) {
      // Llama a `getProductsByMenu` para obtener los productos asociados a la carta
      this.getProductsByMenu(menu.origins, () => {
        // Filtrar solo los productos en uso
        const filteredProducts = [];
        this.productsByMenu.forEach((category) => {
          const productsInUse = this.getProductsInUse(category.products);
          if (productsInUse.length > 0) {
            filteredProducts.push(...productsInUse);
          }
        });

        if (filteredProducts.length === 0) {
          return;
        }

        // Crear un documento PDF
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 10;
        const labelWidth = 80;
        const labelHeight = 40;
        let x = margin;
        let y = margin;

        const currentDate = new Date().toLocaleDateString(); // Fecha actual

        filteredProducts.forEach((product) => {
          try {
            // Dibujar rectángulo para la etiqueta
            doc.rect(x, y, labelWidth, labelHeight);

            // Agregar nombre del producto
            doc.setFontSize(10);
            const maxTextWidth = labelWidth - 36;
            const nameLines = this.wrapTextByWidth(
              doc,
              product.name,
              maxTextWidth
            );
            const lineHeight = 3;

            nameLines.forEach((line, index) => {
              if (index <= 2) {
                if (index == 2 && nameLines.length > 3) line += "...";
                doc.text(line, x + 5, y + 8 + index * lineHeight);
              }
            });
            // Agregar precio en la esquina superior derecha
            doc.setFontSize(14);
            doc.setFont("helvetica", "bold");
            const price = `$${parseFloat(product.currentPrice).toFixed(2)}`;
            const priceWidth = doc.getTextWidth(price);
            doc.text(price, x + labelWidth - priceWidth - 5, y + 14);

            // Generar código de barras
            const barcodeCanvas = document.createElement("canvas");
            JsBarcode(barcodeCanvas, product.sku, {
              format: "CODE128",
              width: 1.5,
              height: 15,
              displayValue: false,
            });
            const barcodeImage = barcodeCanvas.toDataURL("image/png");

            // Agregar código de barras al PDF
            const barcodeY = y + 15;
            doc.addImage(
              barcodeImage,
              "PNG",
              x + 10,
              barcodeY,
              labelWidth - 20,
              15
            );

            // Agregar SKU debajo del código de barras
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            const skuWidth = doc.getTextWidth(product.sku);
            doc.text(
              product.sku,
              x + (labelWidth - skuWidth) / 2,
              barcodeY + 16
            );

            // Agregar fecha de generación en la esquina inferior derecha
            doc.setFontSize(8);
            doc.text(currentDate, x + labelWidth - 20, y + labelHeight - 5);

            // Ajustar posición para la siguiente etiqueta
            x += labelWidth + 5;
            if (x + labelWidth > pageWidth - margin) {
              x = margin;
              y += labelHeight + 5;
            }

            // Saltar de página si se llena la hoja
            if (y + labelHeight > pageHeight - margin) {
              doc.addPage();
              x = margin;
              y = margin;
            }
          } catch (error) {
            console.error("Error al generar etiqueta:", error);
          }
        });

        // Descargar el archivo PDF
        doc.save("etiquetas_productos.pdf");
      });
    },
    wrapTextByWidth(doc, text, maxWidth) {
      const words = text.split(" ");
      const lines = [];
      let currentLine = "";

      for (let word of words) {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        const testWidth = doc.getTextWidth(testLine);

        if (testWidth <= maxWidth) {
          currentLine = testLine;
        } else {
          if (currentLine) lines.push(currentLine);
          if (doc.getTextWidth(word) > maxWidth) {
            const chars = word.split("");
            let subLine = "";
            for (let char of chars) {
              const testSubLine = subLine + char;
              if (doc.getTextWidth(testSubLine) <= maxWidth) {
                subLine = testSubLine;
              } else {
                lines.push(subLine);
                subLine = char;
              }
            }
            if (subLine) lines.push(subLine);
            currentLine = "";
          } else {
            currentLine = word;
          }
        }
      }

      if (currentLine) lines.push(currentLine);
      return lines;
    },
    async onDownloadQr(menu, index) {
      this.createMenuUUIDIfNotExist(menu, index);

      let subdomain = this.getBOrdersSubDomainByInstance();

      await this.createQrWithLogo(
        this.buildMenuPublicUrl(this.selectedList.shopCode, menu.uuid, subdomain)
      )
        .then((url) => {
          var download = document.createElement("a");
          download.href = url;
          download.download = `Menu_${menu.name}_${this.selectedList.shopCode}.png`;
          download.click();
          this.closeDropdown("menu", this.menues.length);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async onDownloadQrPDV(shopCode) {
      const { subdomain, filteredMenue } =
        await this.getSubdomainAndFilteredMenu(shopCode);

      await this.createQrWithLogo(
        this.buildMenuPublicUrl(shopCode, filteredMenue.uuid, subdomain)
      )
        .then((url) => {
          let download = document.createElement("a");
          download.href = url;
          download.download = `Menu_${filteredMenue.name}_${shopCode}.png`;
          download.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async openMenuWeb(shopCode) {
      try {
        const { subdomain, filteredMenue } =
          await this.getSubdomainAndFilteredMenu(shopCode);
        const url = this.buildMenuPublicUrl(shopCode, filteredMenue.uuid, subdomain);
        window.open(url, "_blank");
      } catch (error) {
        console.error("No se pudo abrir la URL:", error.message);
      }
    },
    async getSubdomainAndFilteredMenu(shopCode) {
      try {
        const productsRef = ref(db, `products/${shopCode}/idList`);
        const products = await get(productsRef);
        const idList = products.val();

        const listProductsRef = ref(db, `listProducts/${idList}/menues`);
        const listProducts = await get(listProductsRef);
        const menues = listProducts.val();

        const filteredMenue = menues.find((menu) =>
          menu.origins.some((origin) => origin.name === "Mostrador")
        );

        const subdomain = this.getBOrdersSubDomainByInstance();

        return { subdomain, filteredMenue };
      } catch (error) {
        console.error(
          "Error obteniendo el subdomain y el menú filtrado:",
          error.message
        );
      }
    },
    getRatingBySku(sku, ratingList) {
      if (!ratingList || !sku) return 0;
      const match = ratingList.find((item) => item.sku === sku);
      return match ? match.rating : 0;
    },
    async getRatingFromBackend(productList) {
      const query = {
        shopCode: productList.shopCode,
        idList: productList.id,
      };

      try {
        const res = await axios.get(
          `/api/productsV2/getAverageRatingListFromBackend?${parseToQuery(
            query
          )}`
        );

        if (res.data.responseCode == 0) {
          this.averageRatingList = res.data.summaries;
        } else {
          this.showErrors(res);
        }
      } catch (err) {
        this.showErrors(err.response);
      }
    },
    createMenuUUIDIfNotExist(menu, index) {
      if (menu.uuid !== null && menu.uuid !== undefined) {
        return;
      }

      menu.uuid = this.createUUID();

      const t = this;

      const currentData = ref(db, `listProducts/${t.selectedList.id}`);

      get(currentData).then((snapshot) => {
        const resp = snapshot.val();
        if (resp !== null) {
          resp.menues.splice(index, 1);
          resp.menues.push({
            name: menu.name,
            origins: menu.origins,
            uuid: menu.uuid,
          });

          const dataMenues = ref(
            db,
            `listProducts/${t.selectedList.id}/menues/`
          );

          update(dataMenues, resp.menues);

          t.refreshProductList(t.selectedList, () => {
            t.finishUpsert(menu.origins);
          });
        }
      });
    },
    isExistMenuForThisProduct(prod) {
      return prod?.origins?.length > 0;
    },
    disableProductOnBackEnd(sku) {
      axios
        .post(`/api/productsV2/disableProductOnBackend`, {
          sku: sku,
          shopCode: this.getSelectedShop,
        })
        .then((res) => {
          if (res.data.responseCode === 1) {
            //this.showSuccess(res.data.responseMessage);
          } else if (res.data.responseCode !== 0) {
            //this.showError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          this.showErrors(err.response);
        });
    },
    disableProductOnBackEndPos(sku) {
      axios
        .post(`/api/productsV2/disableProductOnBackend`, {
          sku: sku,
          shopCode: this.shopCode,
        })
        .then((res) => {
          if (res.data.responseCode === 1) {
            //this.showSuccess(res.data.responseMessage);
          } else if (res.data.responseCode !== 0) {
            //this.showError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          this.showErrors(err.response);
        });
    },
    enableProductOnBackEnd(product, shopCode) {
      axios
        .post(`/api/productsV2/enableProductOnBackend`, {
          sku: product.sku,
          department: product.department,
          productName: product.name,
          shopCode: shopCode,
        })
        .then((res) => {
          if (res.data.responseCode === 1) {
            //this.showSuccess(res.data.responseMessage);
          } else if (res.data.responseCode !== 0) {
            //this.showError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          this.showErrors(err.response);
        });
    },
    onConfirmRemove() {
      switch (this.objectToRemove.type) {
        case "Carta":
          this.deleteMenu(
            this.objectToRemove.object,
            this.objectToRemove.index
          );
          this.closeModalById("#modalMenu");
          break;
        case "Producto":
          this.deleteProduct(
            this.objectToRemove.object,
            this.objectToRemove.index
          );
          break;
        case "Adicional":
          this.deleteAditional(this.objectToRemove.object);
          break;
        case "Gusto":
          this.deleteTaste(this.objectToRemove.object);
          break;
        case "Categoría":
          this.deleteCategory(this.objectToRemove.object);
          break;
        case "Combo":
          this.deleteCombo(
            this.objectToRemove.object,
            this.objectToRemove.index
          );
          break;
        case "Ingrediente":
          this.deleteIngredient(
            this.objectToRemove.object,
            this.objectToRemove.index
          );
          break;
        default:
          break;
      }

      this.objectToRemove = null;
      this.closeModalById("#ModalOfConfirmationToRemove");
    },
    onMenuModalClosed() {
      this.currentMenu = null;
    },
    // BPM-26. El estado de sync con los FDS no se borra nunca: si el comercio da
    // de baja una integración, las filas viejas quedan guardadas y la carta
    // seguía mostrando el ícono de ese canal con el resultado del último sync,
    // que puede ser de meses atrás. Devuelve el set de canales que el comercio
    // tiene integrados HOY (normalizados), o null si no se pudo averiguar — en
    // ese caso no se filtra, para no esconder estados válidos por un error
    // transitorio.
    async loadEnabledFdsSlugs(shopCode) {
      if (!shopCode) return null;
      try {
        // Se reusa el composable de integraciones en vez de pegarle al endpoint
        // acá: es el único lugar del proyecto que sabe cómo pedir esta config.
        const { getStoreIntegration } = useIntegrationComposable();
        // Sin loading global: esto corre de fondo mientras se arma la carta y
        // el spinner compartido no lleva contador (ver el composable).
        const data = await getStoreIntegration(shopCode, { withLoading: false });
        if (data?.responseCode !== 0 || !Array.isArray(data?.sources)) return null;
        const slugs = new Set();
        data.sources.forEach((s) => {
          // Integración dada de alta pero con el sync de carta apagado: tampoco
          // corresponde mostrar el resultado de una publicación que ya no ocurre.
          if (s?.isSyncMenuEnabled === false) return;
          const name = getFdsNameBySourceId(s?.source);
          if (name) slugs.add(normalizeFdsOriginName(name));
        });
        return slugs;
      } catch (error) {
        console.warn("No se pudieron leer las integraciones del comercio", error);
        return null;
      }
    },
    getProductsByMenu(origins, callback) {
      const t = this;
      t.productsByMenu = [];
      let productsByDepartment = [];

      const refDataListProducts = ref(db, "listProducts/" + t.selectedList.id);

      // BPM-26: las integraciones vigentes se piden en paralelo con la carta
      // para no agregar un viaje extra antes de mostrar los productos.
      Promise.all([
        t.loadEnabledFdsSlugs(t.selectedList.shopCode),
        get(refDataListProducts),
      ]).then(([enabledFdsSlugs, snapshot]) => {
        t.enabledFdsSlugs = enabledFdsSlugs;
        const resp = snapshot.val();

        if (resp != null) {
          t.joinProductsOrCombosListToMenu(
            productsByDepartment,
            resp.products,
            origins,
            false
          );
          t.joinProductsOrCombosListToMenu(
            productsByDepartment,
            resp.combos,
            origins,
            true
          );
          t.productsByMenu =
            t.orderProductByDepartmentList(productsByDepartment);
          callback();
        } else {
          callback();
        }
      });
    },
    joinProductsOrCombosListToMenu(
      productsByDepartment,
      prodOrComboList,
      origins,
      isCombo
    ) {
      if (prodOrComboList === null || prodOrComboList === undefined) {
        return;
      }
      let fdsSyncInfoList = this.$store.getFdsSyncInformationList;
      let list = Object.entries(prodOrComboList);
      list.forEach((element) => {
        let key = element[0];
        let p = element[1];

        let currentPrice = "";
        let iva = "";
        let fdsSyncStatus = [];

        if (origins.length > 0) {
          if (
            p.origins !== undefined &&
            p.origins !== null &&
            p.origins.length > 0
          ) {
            origins.forEach((o) => {
              let fdsInfoForProduct = fdsSyncInfoList?.filter(
                (x) =>
                  x.productSku === p.sku &&
                  x.origin === o.name?.toUpperCase() &&
                  x.shopCode === this.selectedList.shopCode
              );
              let pOrigin = p.origins?.filter((t) => t.name === o.name);
              if (
                pOrigin !== null &&
                pOrigin !== undefined &&
                pOrigin.length > 0
              ) {
                currentPrice = pOrigin[0].price;
                iva = pOrigin[0].iva;
                if (
                  (fdsInfoForProduct !== null ||
                    fdsInfoForProduct !== undefined) &&
                  fdsInfoForProduct?.length > 0
                ) {
                  // BPM-26: si el comercio ya no tiene integrado ese canal, el
                  // estado guardado es de una publicación que no vuelve a
                  // ocurrir. No se muestra (ver loadEnabledFdsSlugs).
                  const isFdsEnabled =
                    !this.enabledFdsSlugs ||
                    this.enabledFdsSlugs.has(
                      normalizeFdsOriginName(fdsInfoForProduct[0].origin)
                    );
                  if (fdsInfoForProduct[0].syncStatus && isFdsEnabled) {
                    fdsSyncStatus.push({
                      status: fdsInfoForProduct[0].syncStatus,
                      timestamp: fdsInfoForProduct[0].lastUpdateTimestamp,
                      lastError: fdsInfoForProduct[0].syncError,
                      originName: fdsInfoForProduct[0].origin,
                    });
                  }
                }
              }
            });
          }
        }

        let d = productsByDepartment.findIndex((d) => d.name === p.department);
        if (d !== -1) {
          // Categoria existente
          productsByDepartment[d].products.push({
            key: key,
            sku: p.sku,
            name: p.name,
            isProductAvailable: p.isProductAvailable,
            price: "",
            orderInMenu: p.orderInMenu,
            iva: iva,
            currentPrice: currentPrice,
            isCombo: isCombo,
            fdsSyncStatus: fdsSyncStatus,
          });
        } else {
          // Primero de cada categoria
          let array = [];
          array.push({
            key: key,
            sku: p.sku,
            name: p.name,
            isProductAvailable: p.isProductAvailable,
            orderInMenu: p.orderInMenu,
            price: "",
            iva: iva,
            currentPrice: currentPrice,
            isCombo: isCombo,
            fdsSyncStatus: fdsSyncStatus,
          });
          productsByDepartment.push({ name: p.department, products: array });
        }
      });
    },
    orderProductByDepartmentList(productsByDepartment) {
      productsByDepartment.forEach((element) => {
        element.products.sort(function (a, b) {
          if (!a) {
            return true;
          } else if (!b) {
            return false;
          } else
            return a?.name
              ?.toLowerCase()
              ?.localeCompare(b?.name?.toLowerCase(), "es", {
                sensitivity: "base",
              });
        });
      });

      productsByDepartment.sort(function (a, b) {
        if (!a) {
          return true;
        } else if (!b) {
          return false;
        } else
          return a?.name
            ?.toLowerCase()
            ?.localeCompare(b?.name?.toLowerCase(), "es", {
              sensitivity: "base",
            });
      });

      return productsByDepartment;
    },
    onImportDone() {
      // this.getCategories();
      //this.refreshProductList(this.selectedList);
      this.getIngredients(this.selectedList.shopCode);
    },
    deleteProduct(prod, key) {
      this.disableProductOnBackEnd(prod.sku);
      this.deletingProduct = true;     
      const refSetnull = ref(
        db,
        "listProducts/" + this.selectedList.id + "/products/" + key + "/"
      );
      remove(refSetnull)
        .then(() => {
                // Invalidar caché antes de eliminar
        this.invalidateCacheAfterProductOperation(this.selectedList.shopCode);
        this.invalidateCacheAfterListProductsOperation(this.selectedList.id);
      
          this.refreshProductList(this.selectedList);
          toast.success(`El producto ${prod.name} fue eliminado con éxito!`);
          this.shouldShowProductSyncMessage(prod);
          this.deletingProduct = false;
        })
        .catch((error) => {
          console.error("Error updating product:", error);
          this.deletingProduct = false;
        });
    },
    deleteCombo(combo, key) {
      this.deletingCombo = true;
      
      // Invalidar caché antes de eliminar
      this.invalidateCacheAfterProductOperation(this.selectedList.shopCode);  
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);
      
      
      const setProductListsZM = ref(
        db,
        "listProducts/" + this.selectedList.id + "/combos/" + key + "/"
      );

      remove(setProductListsZM)
        .then(() => {
          this.refreshProductList(this.selectedList);
          toast.success(`El combo ${combo.name} fue eliminado con éxito aqui!`);
          this.deletingCombo = false;
        })
        .catch((error) => {
          console.error("Error updating product:", error);
          this.deletingCombo = false;
        });
    },
    deleteIngredient(ingredient, key) {
      const t = this;
      let params = {
        id: key,
      };

      axios
        .put("/api/ingredientsV2/delete", params)
        .then((res) => {
          if (res.data.responseCode === 0) {
            t.showSuccess(
              `El ingrediente ${ingredient.name} fue eliminado con éxito!`
            );
          } else {
            t.showError(res.data.responseMessage);
          }
          t.isLoading = false;
          this.onCloseIngredientModal();
        })
        .catch((err) => {
          t.showErrors(err.response);
          t.isLoading = false;
          this.onCloseIngredientModal();
        });
    },
    hasToUpgradeStockProduct() {
      if (this.currentProduct === null) {
        return false;
      }

      // if (this.currentProduct.sku !== prod.sku || this.currentProduct.name !== prod.name || this.currentProduct.department !== prod.department) {
      // 	return true
      // }

      // return false
      return true;
    },

    replaceSkuInExistantCombos(oldSku, newSku) {
      if (oldSku === newSku) return;
      const t = this;

      const currentListProducts = ref(
        db,
        `listProducts/${this.selectedList.id}/combos`
      );

      get(currentListProducts).then((snapshot) => {
        var resp = snapshot.val();
        if (resp != null) {
          let combos = Object.entries(resp);
          combos.forEach((item) => {
            item[1]?.sections?.forEach((section) => {
              const indexOldSku = section.products.indexOf(oldSku);
              if (indexOldSku != -1) {
                section.products.splice(indexOldSku, 1);
                section.products.push(newSku);

                const updateListProducts = ref(
                  db,
                  `listProducts/${t.selectedList.id}/combos/${item[0]}/`
                );

                update(updateListProducts, item[1]);
              }
            });
          });
        }
      });
    },
    onUpsertProduct(prod, onFinished = null) {
      if (this.deletingProduct) {
        return;
      }

      this.getCategories();
      let c = this.categories.filter((t) => t.name === prod.department);
      if (c !== undefined && c.length > 0) {
        if (
          c[0].hasToPrintInKitchen === undefined ||
          c[0].hasToPrintInKitchen === null
        ) {
          c[0].hasToPrintInKitchen = true;
        }
        if (
          c[0].hasToPrintOnCounter === undefined ||
          c[0].hasToPrintOnCounter === null
        ) {
          c[0].hasToPrintOnCounter = true;
        }
        if (
          c[0].hasToPrintOnAdditionalPrinter === undefined ||
          c[0].hasToPrintOnAdditionalPrinter === null
        ) {
          c[0].hasToPrintOnAdditionalPrinter = true;
        }
        prod.hasToPrintInKitchen = c[0].hasToPrintInKitchen;
        prod.hasToPrintOnCounter = c[0].hasToPrintOnCounter;
        prod.hasToPrintOnAdditionalPrinter = c[0].hasToPrintOnAdditionalPrinter;

        prod.optionsGroups = null;
        if (c[0].optionsGroups !== undefined) {
          prod.optionsGroups = c[0].optionsGroups;
        }
      }

      if (prod.weightable) {
        prod.type = "PESABLE";
      } else if (
        prod.optionsGroups !== null &&
        prod.optionsGroups !== undefined &&
        prod.optionsGroups.length > 0
      ) {
        prod.type = "ADICIONAL";
        prod.measureUnit = "";
      } else {
        prod.type = "PRODUCTO";
        prod.measureUnit = "";
      }

      if (
        prod.origins !== undefined &&
        prod.origins !== null &&
        prod.origins.length > 0 &&
        prod.rootVat !== undefined &&
        prod.rootVat !== null &&
        prod.rootVat !== ""
      ) {
        prod.origins.forEach((element) => {
          element.iva = prod.rootVat;
        });
      }

      if (this.isNewProduct) {
        const refDataListProducts = ref(
          db,
          "listProducts/" + this.selectedList.id + "/products"
        );

        push(refDataListProducts, prod)
          .then(() => {
            off(refDataListProducts);
          })
          .catch((error) => {
            console.error("Error creating product:", error);
          });

        const hasToAvoidShowingProductInsertedModal = localStorage.getItem(
          `modalMenuProductInserted_${this.$store.getAuthUser.user.name}`
        );

        if (
          !hasToAvoidShowingProductInsertedModal ||
          hasToAvoidShowingProductInsertedModal == "false"
        )
          this.openModalById("#modalMenuProductInserted");
      } else {
        const refDataListProducts = ref(
          db,
          "listProducts/" +
            this.selectedList.id +
            "/products/" +
            this.currentProductKey +
            "/"
        );

        update(refDataListProducts, prod)
          .then(() => {
            off(refDataListProducts);
            
            // Validar y mostrar mensaje de sincronización si es necesario
            const shouldSyncWithFds = this.shouldShowProductSyncMessage(prod);
            
            // Ejecutar sincronización si es necesario
            if(shouldSyncWithFds) {
              this.syncFoodDeliverySystemMenues(null, this.selectedList.shopCode);
            }
          })
          .catch((error) => {
            console.error("Error updatimg product:", error);
          });
      }

      // StockProduct (stock 0) + fan-out. En edición con cambio de SKU lo maneja
      // el endpoint de upgrade (hasToUpgradeStockProduct), no dupliquemos acá.
      const productSkuChangedOnEdit =
        !this.isNewProduct && this.currentProduct && this.currentProduct.sku !== prod.sku;
      if (!productSkuChangedOnEdit) {
        this.notifyStockProductUpsert({
          shopCode: this.selectedList.shopCode,
          sku: prod.sku,
          productName: prod.name,
          productCategory: prod.department,
          type: "Product",
          isWeighable: prod.weightable,
          minimunStockQuantity: prod.minimunStockQuantity,
        });
      }

      if (!this.isNewProduct) {
        if (this.currentProduct && prod) {
          this.replaceSkuInExistantCombos(this.currentProduct.sku, prod.sku);
        }
      }

      if (this.hasToUpgradeStockProduct()) {
        let request = {
          shopCode: this.selectedList.shopCode,
          oldSku: this.currentProduct.sku,
          newSku: prod.sku,
          productName: prod.name,
          productCategory: prod.department,
          isWeighable: prod.weightable,
        };

        axios.post(`/api/productsV2/stockProduct`, request).catch((err) => {
          console.error(err.response);
        });
      }

      if (this.currentProduct && this.currentProduct.rootVat != prod.rootVat) {
        this.currentProduct.rootVat = prod.rootVat;
        this.generateShopEvent(
          "BISTROWEB_VAT_CHANGED",
          `${this.currentProduct.name} IVA: ${this.currentProduct.rootVat}`,
          this.selectedList.shopCode,
          this.$store.getAuthUser.user.name
        );
      }

      // Invalidar caché después de upsert
        this.invalidateCacheAfterProductOperation(this.selectedList.shopCode);  
        this.invalidateCacheAfterListProductsOperation(this.selectedList.id);
      
      
      this.closeModalById("#modalProduct");
      this.closeModalById("#modalProductAdvanced");
      this.closeModalById("#modalMenu");
      this.objectToRemove = null;
      this.isNewProduct = false;
      this.clearProduct();
      this.refreshProductList(this.selectedList);
      if (onFinished) {
        onFinished();
      }
    },
    // El alta/edición legacy escribe directo a Firebase; avisamos al backend para
    // que cree (stock 0) o sincronice el StockProduct, con fan-out a comercios hijos
    // Escenario 1. Best-effort: un fallo no afecta el alta del front.
    notifyStockProductUpsert(payload) {
      try {
        axios
          .post("/api/productsV2/stockProduct/upsert", payload)
          .catch((err) => {
            console.error("notifyStockProductUpsert error", err?.response);
          });
      } catch (err) {
        console.error("notifyStockProductUpsert error", err);
      }
    },
    onUpsertCombo(combo) {
      if (this.deletingCombo) {
        return;
      }

      this.getCategories();

      if (
        combo.origins !== undefined &&
        combo.origins !== null &&
        combo.origins.length > 0 &&
        combo.rootVat !== undefined &&
        combo.rootVat !== null &&
        combo.rootVat !== ""
      ) {
        combo.origins.forEach((element) => {
          element.iva = combo.rootVat;
        });
      }

      if (this.isNewCombo) {
        const pushListProductsCombo = ref(
          db,
          "listProducts/" + this.selectedList.id + "/combos"
        );

        push(pushListProductsCombo, combo);
        const hasToAvoidShowingComboInsertedModal = localStorage.getItem(
          `modalMenuComboInserted_${this.$store.getAuthUser.user.name}`
        );

        if (
          !hasToAvoidShowingComboInsertedModal ||
          hasToAvoidShowingComboInsertedModal == "false"
        )
          this.openModalById("#modalMenuComboInserted");
      } else {
        const updateListProductsCombo = ref(
          db,
          "listProducts/" +
            this.selectedList.id +
            "/combos/" +
            this.currentComboKey +
            "/"
        );

        update(updateListProductsCombo, combo);
      }

      // StockProduct del combo. Si cambió el SKU en edición, renombramos el
      // StockProduct (old->new) vía el endpoint de upgrade (con fan-out a hijos);
      // sino, upsert normal (alta o sync de nombre/categoría).
      const comboSkuChangedOnEdit =
        !this.isNewCombo && this.currentCombo && this.currentCombo.sku !== combo.sku;
      if (comboSkuChangedOnEdit) {
        axios
          .post("/api/productsV2/stockProduct", {
            shopCode: this.selectedList.shopCode,
            oldSku: this.currentCombo.sku,
            newSku: combo.sku,
            productName: combo.name,
            productCategory: combo.department,
            isWeighable: false,
          })
          .catch((err) => {
            console.error("combo stockProduct rename error", err?.response);
          });
      } else {
        this.notifyStockProductUpsert({
          shopCode: this.selectedList.shopCode,
          sku: combo.sku,
          productName: combo.name,
          productCategory: combo.department,
          type: "Combo",
        });
      }

      // Invalidar caché tras crear/editar combo (los combos viven bajo
      // listProducts). Sin esto el combo editado seguía mostrando datos viejos.
      this.invalidateCacheAfterProductOperation(this.selectedList.shopCode);
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);

      this.closeModalById("#modalCombo");
      this.objectToRemove = null;
      this.isNewCombo = false;
      this.clearCombo();

      this.refreshProductList(this.selectedList);
    },
    getOptionType() {
      if (this.optionType === "Adicional") {
        return "Adicionales";
      } else {
        return "Gustos";
      }
    },
    async deleteAditional(aditional) {
      this.disableProductOnBackEnd(aditional.sku);

      this.optionType = "Adicional";
      this.calculateInitialCheckCategories(aditional);
      await this.onUpsertOption(aditional, [], false);
      
      toast.success(`El adicional ${aditional.name} fue eliminado con éxito!`);
    },
    async deleteTaste(taste) {
      this.optionType = "Gusto";
      this.calculateInitialCheckCategories(taste);
      await this.onUpsertOption(taste, [], false);

      toast.success(`El gusto ${taste.name} fue eliminado con éxito!`);
    },
    async onUpsertOptionGroup(optionGroupData) {
      const optionGroup = { ...optionGroupData.optionGroup };
      try {
        this.isLoading = true;

        // Determinar si debe sincronizar con FDS: buscar los productos afectados
        // (los de las categorías de las relatedOptions) y delegar al helper unificado
        // que consulta las cartas en Firebase para decidir.
        let shouldSyncWithFds = false;
        const relatedOptions = optionGroup.relatedOptions || [];
        if (relatedOptions.length > 0) {
          const categoriesFromRelatedOptions = await this.getCategoriesFromRelatedOptions(relatedOptions);
          const affectedProducts = this.getProductsInCategories(categoriesFromRelatedOptions);
          shouldSyncWithFds = await this.computeShouldSyncWithFds({
            productListId: this.selectedList?.id,
            products: affectedProducts,
          });
        }

        let params = {
          shopCode: this.selectedList.shopCode,
          name: optionGroup.name,
          canSetPrice: optionGroup.canSetPrice,
          optionGroupId: optionGroup?.optionGroupId || null,
          MinQty: Number(optionGroup.minQty || optionGroup.MinQty) || null,
          MaxQty: Number(optionGroup.maxQty || optionGroup.MaxQty) || null,
          ShouldSyncWithFds: shouldSyncWithFds,
        };

        this.$store.initLoading(this);
        const { data } = await axios.post("/api/advancedProducts/save", params);

        if (data.responseCode === 0) {
          await this.getContextFromBackendForProducts()
          this.getOptionsGroups(); 
          this.getOptions();
          this.$store.finishLoading(this);
          this.showSuccess(
            `Grupo ${
              optionGroupData.isEdit ? "actualizado" : "creado"
            } con éxito`
          );
          if (optionGroupData.isEdit) {           
            const foundOption = this.optionsByGroup.find(option => 
              option.optionGroupIds && 
              option.optionGroupIds.includes(optionGroup?.optionGroupId)
            );
            if (foundOption) {
              this.showSyncMenuMessage(shouldSyncWithFds);
            }
          }
          this.closeModalById("#modalOptionGroup");
          this.isLoading = false;
        } else {
          this.$store.errorLoading(this);
          this.showError(data.responseMessage);
          this.isLoading = false;
        }
      } catch (error) {
        this.$store.errorLoading(this);
        this.isLoading = false;
        this.showError("No se pudo crear el Grupo.");
        
        // Para manejar los errores de backend bien con codigos HTTP
        // if (error.response) {
        //   const status = error.response.status;
        //   const errorData = error.response.data;
          
        //   switch (status) {
        //     case 400:
        //       // Bad Request - validation errors
        //       this.showError(errorData.responseMessage || "Datos inválidos. Por favor, verifica la información ingresada.");
        //       break;
        //     case 404:
        //       // Not Found - resource doesn't exist
        //       this.showError(errorData.responseMessage || "El grupo de opciones no fue encontrado.");
        //       break;
        //     case 409:
        //       // Conflict - e.g., duplicate name
        //       this.showError(errorData.responseMessage || "Ya existe un grupo con ese nombre.");
        //       break;
        //     case 500:
        //       // Internal Server Error
        //       this.showError(errorData.responseMessage || "Error interno del servidor. Por favor, intenta más tarde.");
        //       break;
        //     case 503:
        //       // Service Unavailable
        //       this.showError("El servicio no está disponible. Por favor, intenta más tarde.");
        //       break;
        //     default:
        //       this.showError(errorData.responseMessage || "No se pudo crear el Grupo.");
        //   }
        // } else if (error.request) {
        //   // Request was made but no response received
        //   this.showError("No se pudo conectar con el servidor. Verifica tu conexión.");
        // } else {
        //   // Something else happened
        //   this.showError("No se pudo crear el Grupo.");
        // }
      }
    },
    async onDeleteOptionGroup(optionGroupId) {
      try {
        this.isLoading = true;

        let params = {
          optionGroupId: optionGroupId,
          shopCode: this.selectedList.shopCode,
        };
        this.$store.initLoading(this);

        const { data } = await axios.post(
          "/api/advancedProducts/delete",
          params
        );

        if (data.responseCode === 0) {
          await this.getContextFromBackendForProducts();
          this.getOptionsGroups(); 
          this.$store.finishLoading(this);
          this.showSuccess("Grupo eliminado con éxito!");
          this.closeModalById("#modalOptionGroup");
          this.isLoading = false;
        } else {
          this.$store.errorLoading(this);
          this.showError(data.responseMessage);
          this.isLoading = false;
        }
      } catch (error) {
        this.$store.errorLoading(this);
        this.isLoading = false;
        this.showError("No se pudo eliminar el Grupo.");
      }
    },
    async onUpsertAdvancedOption(option, categoriesChecked) {
      // Determinar si debe sincronizar con FDS: los productos afectados son los de las
      // categorías asociadas a la nueva opción. El helper unificado consulta las cartas
      // en Firebase y decide en base a sus origins.
      const affectedProducts = this.getProductsInCategories(categoriesChecked || []);
      const shouldSyncWithFds = await this.computeShouldSyncWithFds({
        productListId: option.productListId || this.selectedList?.id,
        products: affectedProducts,
      });

      const params = {
        ProductListId: option.productListId,
        Name: option.name,
        Sku: `${option.incrementSku}`,
        Amount: parseFloat(option.amount),
        VatRate: parseFloat(option.vatRate),
        IsExempt: option.isExempt,
        IsNonTaxed: option.isNonTaxed,
        RelatedOptionGroupIds: option.relatedOptionGroupIds,
        EnabledCategories: categoriesChecked,
        ShopCode: option.shopCode,
        shouldSyncWithFds: shouldSyncWithFds,
      };

      try {
        this.$store.initLoading(this);

        const { data } = await axios.post(
          "/api/advancedProducts/saveOptions",
          params
        );

        if (data.responseCode === 0) {
          await this.getContextFromBackendForProducts();
          this.getOptionsGroups();
          this.getOptions();
          this.$store.finishLoading(this);
          this.showSuccess("Opción creada con éxito!");
          this.showSyncMenuMessage(shouldSyncWithFds)
          this.closeModalById("#modalAdvancedOptions");
        } else {
          toast.error(data.responseMessage);
          this.$store.errorLoading(this);
        }
      } catch (error) {
        this.$store.errorLoading(this);
        this.showError("No se pudo crear la opción.");
      }
    },
    async editOption(option, categoriesChecked, originalCategories = []) {
      // Determinar si debe sincronizar con FDS: los productos afectados son los de la
      // unión entre categorías originales (se pueden estar sacando del FDS) y nuevas
      // (se pueden estar agregando). El helper unificado consulta las cartas en Firebase.
      const allAffectedCategories = [
        ...new Set([...(originalCategories || []), ...(categoriesChecked || [])]),
      ];
      const affectedProducts = this.getProductsInCategories(allAffectedCategories);
      const shouldSyncWithFds = await this.computeShouldSyncWithFds({
        productListId: option.productListId || this.selectedList?.id,
        products: affectedProducts,
      });

      const params = {
        OptionId: option.optionId,
        ProductListId: option.productListId,
        Name: option.name,
        Sku: option.sku,
        Amount: parseFloat(option.amount),
        VatRate: parseFloat(option.vatRate),
        IsExempt: option.isExempt,
        IsNonTaxed: option.isNonTaxed,
        RelatedOptionGroupIds: option.relatedOptionGroupIds,
        EnabledCategories: categoriesChecked,
        ShopCode: option.shopCode,
        shouldSyncWithFds: shouldSyncWithFds,
      };

      try {
        this.$store.initLoading(this);

        const { data } = await axios.post(
          "/api/advancedProducts/editOption",
          params
        );

        if (data.responseCode === 0) {
          await this.getContextFromBackendForProducts();
          //   (() => {
          //   this.getOptionsGroups();
          //   this.getOptions();
          // });
          this.getOptionsGroups();
          this.getOptions();
          this.$store.finishLoading(this);
          this.showSuccess("Opción editada con éxito!");
          this.showSyncMenuMessage(shouldSyncWithFds)
          this.closeModalById("#modalAdvancedOptions");
        } else {
          toast.error(data.responseMessage);
          this.$store.errorLoading(this);
        }
      } catch (error) {
        this.$store.errorLoading(this);
        this.showError("No se pudo editar la opción.");
      }
    },
    async deleteOption(option) {
      try {
        this.$store.initLoading(this);

        // Determinar si debe sincronizar con FDS: los productos afectados son los de las
        // categorías de la opción que se está eliminando.
        const categoriesToDelete = option.checkedCategoriesFromBackend || [];
        const affectedProducts = this.getProductsInCategories(categoriesToDelete);
        const shouldSyncWithFds = await this.computeShouldSyncWithFds({
          productListId: option.productListId || this.selectedList?.id,
          products: affectedProducts,
        });

        const params = {
          ...option,
          ShouldSyncWithFds: shouldSyncWithFds,
        };

        const { data } = await axios.post(
          "/api/advancedProducts/deleteOption",
          params
        );

        if (data.responseCode === 0) {
          await this.getContextFromBackendForProducts();
          this.getOptionsGroups();
          this.getOptions();
          this.$store.finishLoading(this);
          this.showSuccess("Opción eliminada con éxito!");
          this.showSyncMenuMessage(shouldSyncWithFds)
          this.closeModalById("#modalAdvancedOptions");
        } else {
          toast.error(data.responseMessage);
          this.$store.errorLoading(this);
        }
      } catch (error) {
        this.$store.errorLoading(this);
        this.showError("No se pudo eliminar la opción.");
      }
    },
    async onUpsertOption(option, checkedCategories, showMessages = true) {

      // Invalidar caché antes de crear/editar/eliminar  adicional o gusto.
      // El adicional/gusto aparece dentro de los productos (tab ADICIONALES),
      // por lo que además de categorías hay que invalidar products_ y listProducts_;
      // sin esto el cambio no se refleja hasta recargar.
      this.invalidateCacheForCategoryOperation(this.selectedList.shopCode);
      this.invalidateCacheAfterProductOperation(this.selectedList.shopCode);
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);

      const t = this;
      let initialCheckedCategories = this.initialCheckedCategories;
      let listOfCheckedCategories = [];
      let optionType = t.getOptionType();
      const optionTypeToast = this.optionType;
      const isNewOptionToast = this.isNewOption;
      let errorMessage = "";
      let error = false;

      if (optionType === "Adicionales") {
        option.minQty = parseInt(option.minQty);
        option.maxQty = 99;
        option.price = (Math.round(option.price * 100) / 100).toFixed(2);
      } else {
        option.minQty = 0;
        option.maxQty = 99;
        option.price = "0.00";
        option.exempt = false;
        option.nonTaxed = false;
      }

      if (
        option.sku === undefined ||
        option.sku === null ||
        option.sku === ""
      ) {
        option.sku = `98${Math.floor(Math.random() * 999999999).toString()}`;
      }

      let listOfShops = this.$store.getMerchantTags;
      let selectedListCategoriesProcessed = false;

      const categoriesSaved = listOfShops.map((shop) => {
        const itemsDataProds = [];
        // BS-6241 / Firebase opt: leer solo idList y categories (los únicos campos
        // que se usan) en paralelo, en lugar del nodo completo `products/{shop}`.
        const basePath = "products/" + shop.shopCode;
        const idListRef = ref(db, basePath + "/idList");
        const categoriesRef = ref(db, basePath + "/categories");

        let currentDataTrigger = false;

        return Promise.all([get(idListRef), get(categoriesRef)]).then(([idListSnap, categoriesSnap]) => {
          if (!currentDataTrigger) {
            currentDataTrigger = true;
            const idList = idListSnap.val();
            const categories = categoriesSnap.val();
            var list = idList != null ? { idList, categories } : null;

            if (!itemsDataProds.includes(list?.idList)) {
              itemsDataProds.push(list?.idList);

              if (list !== null) {
                if (list?.idList === t.selectedList.id) {
                  initialCheckedCategories.forEach((category) => {
                    var c = list.categories.filter((t) => t.name === category);
                    if (c !== null && c !== undefined && c.length > 0) {
                      let obj = c[0];

                      let og = c[0].optionsGroups.filter(
                        (t) => t.name === optionType
                      );
                      if (og.length > 0) {
                        var o = og[0].options.filter(
                          (t) => t.name === option.name
                        );
                        if (o.length > 0) {
                          var index = og[0].options.indexOf(o[0]);
                          og[0].options.splice(index, 1);

                          index = c[0].optionsGroups.indexOf(og[0]);
                          c[0].optionsGroups.splice(index, 1);

                          if (og[0].options.length > 0) {
                            c[0].optionsGroups.push(og[0]);
                          }

                          var i = list.categories.indexOf(obj);
                          list.categories.splice(i, 1);

                          list.categories.push(c[0]);
                        }
                      }
                    }
                  });
                  checkedCategories.forEach((category) => {
                    var c = list.categories.filter((t) => t.name === category);

                    if (c !== null && c !== undefined && c.length > 0) {
                      let obj = c[0];
                      if (
                        c[0].optionsGroups === null ||
                        c[0].optionsGroups === undefined
                      ) {
                        c[0].optionsGroups = [];
                      }

                      let o = c[0].optionsGroups.filter(
                        (t) => t.name === optionType
                      );

                      if (o.length === 0) {
                        //Si la categoria era nueva, no va a tener optionGroups asociados asi que creo el option group y le paso esta opcion
                        c[0].optionsGroups.push({
                          name: optionType,
                          minQty:
                            c[0].hasToEnableFlavorLimit ?? false
                              ? c[0].minimumFlavorLimit
                              : option.minQty, //agregar minimo de flavor
                          maxQty:
                            c[0].hasToEnableFlavorLimit ?? false
                              ? c[0].maximumFlavorLimit
                              : option.maxQty, //agregar maximo de flavor
                          options: [
                            {
                              name: option.name,
                              minQty: Math.min(
                                option.minQty,
                                c[0].hasToEnableFlavorLimit ?? false
                                  ? c[0].maximumFlavorLimit
                                  : option.maxQty
                              ), //dejarlo como esta porque puede ser 0 asi no esta obligado a meter un gusto o adicional, eso lo limita el option group
                              maxQty:
                                c[0].hasToEnableFlavorLimit ?? false
                                  ? c[0].maximumFlavorLimit
                                  : option.maxQty, //setearle el maximo del flavor
                              price: option.price,
                              vat: option.vat,
                              sku: option.sku,
                              exempt: option.exempt,
                              nonTaxed: option.nonTaxed,
                            },
                          ],
                        });
                      } else {
                        //Si la categoria ya tenia option groups entro aca

                        let op = o[0].options.filter(
                          (t) =>
                            t.name?.toUpperCase() == option.name?.toUpperCase()
                        );

                        if (op.length === 0) {
                          //si no existe una opcion con ese nombre dentro del option group
                          var index = c[0].optionsGroups.indexOf(o[0]);
                          c[0].optionsGroups.splice(index, 1);

                          o[0].options.push({
                            name: option.name,
                            minQty: Math.min(
                              option.minQty,
                              c[0].hasToEnableFlavorLimit ?? false
                                ? c[0].maximumFlavorLimit
                                : option.maxQty
                            ),
                            maxQty:
                              c[0].hasToEnableFlavorLimit ?? false
                                ? c[0].maximumFlavorLimit
                                : option.maxQty, //le tengo que meter el maximo del option group en el que esta
                            price: option.price,
                            vat: option.vat,
                            sku: option.sku,
                            exempt: option.exempt,
                            nonTaxed: option.nonTaxed,
                          });

                          c[0].optionsGroups.push(o[0]);
                        } else {
                          errorMessage = `El adicional ${option.name} ya existe`;
                          error = true;
                        }
                      }
                      var i = list.categories.indexOf(obj);
                      list.categories.splice(i, 1);

                      list.categories.push(c[0]);
                      listOfCheckedCategories.push(c[0]);
                    }
                  });

                  const updateProductsCategories = ref(
                    db,
                    "products/" + t.selectedList.shopCode + "/categories"
                  );

                  set(updateProductsCategories, list.categories);
                  t.getCategories();
                  selectedListCategoriesProcessed = true;
                }
              }
            } //cierra la condicion
          }
        });
      });

      // BPM-38: los productos se arman con `listOfCheckedCategories`, que se
      // llena al procesar las categorías. Si `listProducts` respondía primero,
      // el loop cortaba en `c[0]` y los productos restantes no se guardaban:
      // la categoría perdía el adicional y esos productos lo conservaban.
      // `allSettled`: que falle la lectura de otro comercio no frena esta
      // lista. Si fallan las categorías de la lista seleccionada no se tocan
      // los productos, para no desincronizarlos al revés.
      const listProductsData = ref(
        db,
        "listProducts/" + t.selectedList.id + "/products"
      );
      let listProductsTrigger = false;
      Promise.allSettled(categoriesSaved).then(() => {
        if (!selectedListCategoriesProcessed) {
          throw new Error(`Categories of list ${t.selectedList.id} were not processed`);
        }
        return get(listProductsData);
      }).then((snapshot) => {
        if (!listProductsTrigger) {
          listProductsTrigger = true;
          const resp = snapshot.val();
          if (resp !== null) {
            let prods = Object.entries(resp);
            prods.forEach((prod) => {
              if (
                prod[1].optionsGroups === null ||
                prod[1].optionsGroups === undefined
              ) {
                prod[1].optionsGroups = [];
              }
              if (
                initialCheckedCategories.filter((t) => t === prod[1].department)
                  .length > 0
              ) {
                let og = prod[1].optionsGroups.filter(
                  (t) => t.name === optionType
                );
                if (og !== undefined && og !== null && og.length > 0) {
                  var o = og[0].options.filter((t) => t.name === option.name);
                  if (o !== undefined && o !== null && o.length > 0) {
                    var index = og[0].options.indexOf(o[0]);
                    og[0].options.splice(index, 1);

                    index = prod[1].optionsGroups.indexOf(og[0]);
                    prod[1].optionsGroups.splice(index, 1);

                    if (og[0].options.length > 0) {
                      prod[1].optionsGroups.push(og[0]);
                    }
                  }
                }
              }
              if (
                checkedCategories.filter((t) => t === prod[1].department)
                  .length > 0
              ) {
                let c = listOfCheckedCategories.filter(
                  (t) => t.name === prod[1].department
                );
                let o = prod[1].optionsGroups.filter(
                  (t) => t.name === optionType
                );
                // Sin la categoría en el catálogo no hay de dónde sacar el
                // límite de gustos: no se le asigna, pero el loop sigue.
                if (c.length > 0 && o.length === 0) {
                  // BPM-38: el producto recibe una copia del grupo tal como quedó
                  // en la categoría (todas sus opciones y su min/max), igual que
                  // `onUpsertProduct`. Armarlo solo con la opción que se guarda
                  // lo dejaba con 1 opción aunque la categoría tuviera más.
                  // Si la categoría no tiene el grupo no se le asigna nada al
                  // producto, pero el loop sigue con el resto.
                  const categoryGroup = c[0].optionsGroups?.find(
                    (group) => group.name === optionType
                  );
                  if (categoryGroup) {
                    prod[1].optionsGroups.push(
                      JSON.parse(JSON.stringify(categoryGroup))
                    );
                  } else {
                    console.warn(
                      `BPM-38: group "${optionType}" not found in category "${prod[1].department}", skipping product sku ${prod[1].sku}`
                    );
                  }
                } else if (
                  c.length > 0 &&
                  // BPM-38: igual que en la categoría, si el producto ya tiene
                  // la opción no se vuelve a agregar (quedaba duplicada).
                  !o[0].options.some(
                    (t) => t.name?.toUpperCase() === option.name?.toUpperCase()
                  )
                ) {
                  var i = prod[1].optionsGroups.indexOf(o[0]);
                  prod[1].optionsGroups.splice(i, 1);

                  o[0].options.push({
                    name: option.name,
                    minQty: Math.min(
                      option.minQty,
                      c[0].hasToEnableFlavorLimit ?? false
                        ? c[0].maximumFlavorLimit
                        : option.maxQty
                    ),
                    maxQty:
                      c[0].hasToEnableFlavorLimit ?? false
                        ? c[0].maximumFlavorLimit
                        : option.maxQty,
                    price: option.price,
                    vat: option.vat,
                    sku: option.sku,
                    exempt: option.exempt,
                    nonTaxed: option.nonTaxed,
                  });

                  prod[1].optionsGroups.push(o[0]);
                }
              }
              if (prod[1].type !== "PESABLE") {
                if (
                  prod[1].optionsGroups !== undefined &&
                  prod[1].optionsGroups !== null &&
                  prod[1].optionsGroups.length > 0
                ) {
                  prod[1].type = "ADICIONAL";
                } else {
                  prod[1].type = "PRODUCTO";
                }
              }

              // if (this.savingControl) return;

              // this.savingControl = true;

              const updateListProducts = ref(
                db,
                "listProducts/" + t.selectedList.id + "/products/" + prod[0]
              );

              set(updateListProducts, prod[1])
                .catch((error) => {
                  console.error("Error updating product:", error);
                });
            });
          }

          t.refreshProductList(t.selectedList);

          if (showMessages) {
            if (error) {
              toast.error(errorMessage);
            } else {
              if (isNewOptionToast) {
                toast.success(
                  `El ${optionTypeToast} ${option.name} se creó exitosamente!`
                );
                this.savingControl = false;
              } else {
                toast.success(
                  `El ${optionTypeToast} ${option.name} se guardó exitosamente!`
                );   
                this.savingControl = false;
              }
            }
          }

          const allAffectedCategories = [...new Set([...initialCheckedCategories, ...checkedCategories])];
          const shouldSyncWithFds = this.shouldShowSyncMenuMessage(allAffectedCategories);
          if (shouldSyncWithFds) {
            this.syncFoodDeliverySystemMenues(null, this.selectedList.shopCode);
          }
        }
      }).catch((err) => {
        console.error("Error updating option in products:", err);
        toast.error(
          `No se pudo guardar el ${optionTypeToast} ${option.name} en los productos. Volvé a intentarlo.`
        );
      });

      // StockProduct (Type=Option, stock 0) + fan-out, en alta/edición de
      // adicional o gusto. Si checkedCategories viene vacío es una BAJA
      // (deleteAditional/deleteTaste) -> no creamos StockProduct.
      if (checkedCategories && checkedCategories.length > 0) {
        const firstCategory = checkedCategories[0];
        this.notifyStockProductUpsert({
          shopCode: this.selectedList.shopCode,
          sku: option.sku,
          productName: option.name,
          productCategory:
            typeof firstCategory === "string"
              ? firstCategory
              : firstCategory?.name || null,
          type: "Option",
        });
      }

      this.closeModalById("#modalOption");
      this.objectToRemove = null;
      this.clearOption();
    },
    deleteMenu(menu, index) {
      // Invalidar caché antes de eliminar menú
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);
      
      this.products.forEach((prod) => {
        let isModified = false;

        if (
          prod[1].origins !== undefined &&
          prod[1].origins !== null &&
          prod[1].origins.length > 0
        ) {
          menu.origins.forEach((o) => {
            let i = prod[1].origins.findIndex((t) => t.name === o.name);

            if (i !== -1 && i !== undefined && i !== null) {
              prod[1].origins.splice(i, 1);
              isModified = true;
            }
          });

          if (isModified) {
            const setLP = ref(
              db,
              "listProducts/" + this.selectedList.id + "/products/" + prod[0]
            );

            set(setLP, prod[1])
              .then(() => {
                off(setLP);
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        }
      });

      this.menues.splice(index, 1);

      const setLProds = ref(
        db,
        "listProducts/" + this.selectedList.id + "/menues/"
      );

      set(setLProds, this.menues);

      this.updateOriginsInUse();

      this.refreshProductList(this.selectedList);
      const shopTheme = this.$store.getCurrentShopTheme;
      switch (shopTheme) {
        case 1:
        default:
          toast.success(`La carta ${menu.name} fue eliminada con éxito!`);
          return;
        case 2:
          toast.success(`El catálogo ${menu.name} fue eliminado con éxito!`);
          return;
      }
    },
    onUpsertMenu(menu, productsByMenu, originsOut, resultOrigins, availabilityOnly = null) {
      //if (this.onUpsertMenuNro < 2) {
      //this.onUpsertMenuNro++;

      // BS-6442: lo calculó ModalMenu comparando contra el snapshot de apertura. Se setea SIEMPRE
      // (null incluido) para que un guardado no herede el delta del anterior.
      this.pendingAvailabilityOnly = availabilityOnly;

      // Invalidar caché antes de crear/editar menú
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);

      const t = this;

      const LPValue = ref(db, `listProducts/${t.selectedList.id}`);

      let countMyList = 0;
      let LPValueLimit = false;
      let finishUpsert = false;

      get(LPValue).then((snapshot) => {
        if (!LPValueLimit) {
          LPValueLimit = true;

          const data = snapshot.val();

          const resp = snapshot.val();
          if (resp !== null) {
            if (resp.menues === undefined) {
              resp.menues = [];
            }
            if (menu.key === "") {
              resp.menues.push({
                name: menu.name,
                origins: resultOrigins,
                uuid: t.createUUID(),
              });
            } else {
              if (menu.uuid === null || menu.uuid === undefined) {
                menu.uuid = t.createUUID();
                resp.menues.splice(menu.key, 1);
              } else {
                const menuFromFbIndex = resp.menues.findIndex(
                  (x) => x.uuid === menu.uuid
                );
                resp.menues.splice(menuFromFbIndex, 1);
              }

              resp.menues.push({
                name: menu.name,
                origins: resultOrigins,
                uuid: menu.uuid,
              });
            }

            if (this.savingControl) return;

            this.savingControl = true;

            const updateListProductsMenues = ref(
              db,
              `listProducts/${t.selectedList.id}/menues/`
            );

            //set(updateListProductsMenues, resp.menues);
            //"-NrMTGErSTbziwvyPRWu"

            set(updateListProductsMenues, resp.menues)
              .then(() => {
                off(updateListProductsMenues);
              })
              .catch((error) => {
                console.error("Error updating product:", error);
              });

            if (resp.products === null || resp.products === undefined) {
              t.refreshProductList(t.selectedList, () => {
                t.finishUpsert(resultOrigins);
              });
              return;
            }

            t.updateProductsOrCombos(
              resp.products,
              productsByMenu,
              originsOut,
              resultOrigins,
              false,
              `${t.selectedList.id}/products`
            );
            t.updateProductsOrCombos(
              resp.combos,
              productsByMenu,
              originsOut,
              resultOrigins,
              true,
              `${t.selectedList.id}/combos`
            );

            if (!finishUpsert) {
              finishUpsert = true;
              t.refreshProductList(t.selectedList, () => {
                t.finishUpsert(resultOrigins);
              });
            }
          }
        } //LPValueLimit
      });
      //}
    },
    updateProductsOrCombos(
      productsOrCombosList,
      productsByMenu,
      originsOut,
      resultOrigins,
      isCombo,
      nodoPath
    ) {
      if (productsOrCombosList === null || productsOrCombosList === undefined) {
        return;
      }
      var list = Object.entries(productsOrCombosList);

      //let mycounter = 0;

      productsByMenu.forEach((department) => {

        let prodready = [];

        department.products
          .filter((t) => t.isCombo === isCombo)
          .forEach((prod) => {
            let p = list.filter((t) => t[0] === prod.key)[0];
            if (p !== -1 && p !== undefined && p !== null && p.length > 0) {
              if (!prodready.includes(p[0])) {
                prodready.push(p[0]);

                p[1].isProductAvailable = prod?.isProductAvailable ?? true;

                /// Estos son los origenes que se sacaron
                originsOut.forEach((o) => {
                  if (p[1].origins === undefined) {
                    p[1].origins = [];
                  }
                  let originsToTakeOut = p[1].origins.filter(
                    (t) => t.name === o
                  );
                  if (
                    originsToTakeOut !== -1 &&
                    originsToTakeOut !== undefined &&
                    originsToTakeOut !== null &&
                    originsToTakeOut.length > 0
                  ) {
                    let index = p[1].origins.indexOf(originsToTakeOut[0]);
                    p[1].origins.splice(index, 1);
                  }
                });

                // Estos son los origenes que quedaron prendidos.. actuar
                resultOrigins.forEach((o) => {
                  if (p[1].origins === undefined) {
                    p[1].origins = [];
                  }

                  let origins = p[1].origins.filter((t) => t.name === o.name);
                  if (
                    origins !== -1 &&
                    origins !== undefined &&
                    origins !== null &&
                    origins.length > 0
                  ) {
                    let index = p[1].origins.indexOf(origins[0]);
                    p[1].origins.splice(index, 1);
                  } else {
                    origins = [{}];
                  }

                  if (
                    p[1].rootVat === undefined ||
                    p[1].rootVat === null ||
                    p[1].rootVat === ""
                  ) {
                    if (
                      prod.iva !== undefined &&
                      prod.iva !== null &&
                      prod.iva !== ""
                    ) {
                      p[1].rootVat = prod.iva;
                    } else {
                      p[1].rootVat = "21.00";
                    }
                  }

                  if (prod.currentPrice !== "") {
                    let price = 0;
                    if (prod.price !== "") {
                      price = (Math.round(prod.price * 100) / 100).toFixed(2);
                    } else {
                      price = (
                        Math.round(prod.currentPrice * 100) / 100
                      ).toFixed(2);
                    }

                    origins[0].iva = p[1].rootVat;
                    origins[0].name = o.name;
                    origins[0].price = price;

                    origins = [
                      { iva: p[1].rootVat, name: o.name, price: price },
                    ];

                    p[1].origins.push(origins[0]);
                  }
                });

                const updateListProductsP = ref(
                  db,
                  `listProducts/${nodoPath}/${p[0]}`
                );

                set(updateListProductsP, p[1])
                  .then(() => {
                    off(updateListProductsP);
                  })
                  .catch((error) => {
                    console.error("Error SETUPDATELISTPRODUCTSP");
                  });
              }
            }
          });
      });
    },
    syncFoodDeliverySystemMenues(menuOrigins, shopCode, availabilityOnly = null) {
      axios
        .post(
          `/api/productsV2/syncProductsWithFds`,
          buildSyncProductsWithFdsPayload(menuOrigins, shopCode, availabilityOnly)
        )
        .then((res) => {
          if (res.data.responseCode === 1) {
            //this.showSuccess(res.data.responseMessage);
          } else if (res.data.responseCode !== 0) {
            //this.showError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          this.showErrors(err.response);
        });
    },
    generateShopEvent(type, description, shopCode, userName) {
      axios
        .post(`/api/eventsV2/generateShopEvent`, {
          type: type,
          creationTimestamp: new Date().toISOString(),
          description: description,
          userName: userName,
          shopCode: shopCode,
        })
        .then((res) => {
          if (res.data.responseCode === 0) {
            //this.showSuccess(res.data.responseMessage);
          } else {
            //this.showError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          console.error(`generateShopEvent`, err);
        });
    },
    onModalMessageClosing() {
      this.closeModalById("#modalMenuUpsertFinished");
    },
    onModalProductMessageClosing() {
      this.closeModalById("#modalMenuProductInserted");
    },
    onModalComboMessageClosing() {
      this.closeModalById("#modalMenuComboInserted");
    },
    getMenuTypeLabel() {
      const shopTheme = this.getShopTheme(this.selectedList.shopCode);
      // 1 = Gastronómico (default), otros valores = Retail
      return shopTheme === 1 ? "carta" : "catálogo";
    },
    finishUpsert(menuOrigins) {
      //if (!this.controlVariablex) {
      // this.controlVariablex = true;

      this.updateOriginsInUse();

      if (this.isNewMenu) {
        toast.success(`La ${this.getMenuTypeLabel()} se creó exitósamente!`);
        this.savingControl = false;
      } else {
        toast.success(`La ${this.getMenuTypeLabel()} ${this.currentMenu} se guardo exitósamente!`);
        this.savingControl = false;
      }

      // BS-6442: si el guardado fue solo de disponibilidad, va el sync liviano (turn_off por SKU).
      // Se limpia el delta acá para que un guardado posterior no lo reutilice.
      const availabilityOnly = this.pendingAvailabilityOnly ?? null;
      this.pendingAvailabilityOnly = null;

      this.syncFoodDeliverySystemMenues(
        menuOrigins,
        this.selectedList.shopCode,
        availabilityOnly
      );
      this.generateShopEvent(
        "BISTROWEB_MENU_AND_OR_PRICES_CHANGED",
        `Carta: ${this.currentMenu}`,
        this.selectedList.shopCode,
        this.$store.getAuthUser.user.name
      );

      this.closeModalById("#modalMenu");
      const hasToAvoidShowingMenuUpsertWarningModal = localStorage.getItem(
        `modalMenuUpsertFinished_${this.$store.getAuthUser.user.name}`
      );

      if (
        !hasToAvoidShowingMenuUpsertWarningModal ||
        hasToAvoidShowingMenuUpsertWarningModal == "false"
      )
        this.openModalById("#modalMenuUpsertFinished");
      this.isMenuLoading = false;
      this.clearMenu();
      this.onMenuModalClosed();
      this.objectToRemove = null;
    },
    updateOriginsInUse() {
      let originsInUse = [];
      if (
        this.menues !== undefined &&
        this.menues !== null &&
        this.menues.length > 0
      ) {
        this.menues.forEach((menu) => {
          menu.origins.forEach((origin) => {
            originsInUse.push(origin);
          });
        });
      }

      let listOfShops = this.$store.getMerchantTags;
      listOfShops.forEach((shop) => {
        const setProducts = ref(db, "products/" + shop.shopCode + "/origins");
        set(setProducts, originsInUse);
      });

      const setPL = ref(
        db,
        "listProducts/" + this.selectedList.id + "/origins"
      );
      set(setPL, originsInUse);
    },
    async deleteCategory(category) {
      // 🔍 Validaciones previas
      const validationError = this.validateCategoryForDeletion(category);
      if (validationError) {
        toast.error(validationError);
        return;
      }

      try {
        // 🗑️ Eliminar categoría de Firebase
        await this.removeCategoryFromFirebase(category);
        
        // 🏢 Eliminar asociaciones de workstations (si aplica)
        await this.removeWorkstationAssociations(category);
        
        // ✅ Actualizar UI y caché
        await this.updateAfterCategoryDeletion();
        
        toast.success(`La categoría ${category.name} fue eliminada con éxito!`);
      } catch (error) {
        toast.error("Error al eliminar la categoría. Intente nuevamente.");
      }
    },

    // 🔍 Valida si la categoría puede ser eliminada
    validateCategoryForDeletion(category) {
      // Verificar productos asociados
      const hasAssociatedProducts = this.products.some(([, prod]) => 
        prod.department === category.name
      );
      if (hasAssociatedProducts) {
        return `Esta categoría posee productos asociados. Modifique sus productos si desea eliminarla!`;
      }

      // Verificar combos asociados
      const hasAssociatedCombos = this.combos.some(([, combo]) => 
        combo.department === category.name
      );
      if (hasAssociatedCombos) {
        return `Esta categoría posee combos asociados. Modifique sus combos si desea eliminarla!`;
      }

      // Verificar opciones/adicionales asociados
      if (category.optionsGroups?.length > 0) {
        return `Esta categoría posee adicionales o gustos asociados. Modifique sus categorías si desea eliminarla!`;
      }

      return null; // Sin errores
    },

    // 🗑️ Elimina la categoría de Firebase
    async removeCategoryFromFirebase(category) {
      const shopCode = this.selectedList.shopCode;
      const valueProducts = ref(db, `products/${shopCode}`);
      
      const snapshot = await get(valueProducts);
      const list = snapshot.val();

      if (!list || !list.categories || list.idList !== this.selectedList.id) {
        throw new Error("No se encontró la lista de categorías en Firebase");
      }

      const categoryIndex = list.categories.findIndex(c => c.name === category.name);
      if (categoryIndex === -1) {
        throw new Error("Categoría no encontrada en Firebase");
      }

      // Eliminar categoría del array
      list.categories.splice(categoryIndex, 1);

      // Guardar en Firebase
      const categoriesRef = ref(db, `products/${shopCode}/categories`);
      await set(categoriesRef, list.categories);
    },

    // 🏢 Elimina asociaciones de workstations
    async removeWorkstationAssociations(category) {
      if (!this.shouldShowWorkstations) return;

      try {
        await axios.delete('/api/workstations/deleteWorkstationsCategories', {
          data: {
            categoryName: category.name,
            shopCode: this.selectedList.shopCode
          }
        });
      } catch (error) {
        console.error('Error al eliminar las estaciones de trabajo:', error);
      }
    },
    // ✅ Actualiza UI y caché después de eliminación exitosa
    async updateAfterCategoryDeletion() {
      // Invalidar caché
      this.invalidateCacheAfterCategoryDeletion();
      // Recargar categorías
      await this.getCategories();
    },
    isCategoryNameInFirebase(list, category, t, oldCategoryName) {      
      // Validar que category.name exista
      if (!category.name) return false;
      
      // Si estamos editando y el nombre no cambió, no validar duplicados
      if (oldCategoryName && oldCategoryName.toLowerCase() === category.name.toLowerCase()) return false;
      
      // Validar que list.categories exista y sea un array
      if (!list || !list.categories || !Array.isArray(list.categories)) return false
      
      // Verifica si ya existe una categoría con el mismo nombre (ignorando mayúsculas/minúsculas)
      // Filtra categorías corruptas sin nombre antes de comparar
      const categoryExists = list.categories.some(
        (t) => t.name && t.name.toLowerCase() === category.name.toLowerCase()
      );      
      if (categoryExists) {
        toast.error(`La categoría ${category.name} ya existe!`);
        return true;
      } else return false;
    },
    onUpsertCategory(category) {
      // Invalidar caché antes de crear/editar categoría
      this.invalidateCacheForCategoryOperation(this.selectedList.shopCode);
      this.invalidateCacheAfterListProductsOperation(this.selectedList.id);
      
      const t = this;
      let oldCategoryName = t.oldCategoryName; //Es null si la categoria es nueva
      if (t.isNewCategory) {
        let dataShopsId = [];

        const currentValueProducts = ref(
          db,
          `products/${this.selectedList.shopCode}`
        );
        get(currentValueProducts).then(async (snapshot) => {
          var list = snapshot.val();

          if (!dataShopsId.includes(list?.idList)) {
            dataShopsId.push(list?.idList);

            let nameInCamelCase = category.name; // FIXME::: To CamelCase
            if (list.categories === undefined || list.categories === null) {
              //La lista esta vacía.
              list.categories = [];
              list.categories.push({
                name: nameInCamelCase,
                orderNumber: category.orderNumber || null,
                hasToPrintInKitchen: category.hasToPrintInKitchen,
                hasToPrintOnCounter: category.hasToPrintOnCounter,
                hasToPrintOnAdditionalPrinter:
                  category.hasToPrintOnAdditionalPrinter,
                hasToAcceptReviews: category.hasToAcceptReviews,
                hasToEnableFlavorLimit: category.hasToEnableFlavorLimit,
                minimumFlavorLimit: category.minimumFlavorLimit,
                maximumFlavorLimit: category.maximumFlavorLimit,
              });
              const updateProductsCat = ref(
                db,
                `products/${t.selectedList.shopCode}/categories`
              );
              set(updateProductsCat, list.categories);
            } else {
              //Pregunto si existe, ya que la lista no está vacía.
              if (
                t.isCategoryNameInFirebase(list, category, t, oldCategoryName)
              ) {
                //Retornó verdadero, por lo tanto, existía.
                if (t.$refs.ModalCategory) {
                  t.$refs.ModalCategory.resetLoadingState();
                }
                return;
              }
              //Si no existía, la creo
              list.categories.push({
                name: nameInCamelCase,
                orderNumber: category.orderNumber || null,
                hasToPrintInKitchen: category.hasToPrintInKitchen,
                hasToPrintOnCounter: category.hasToPrintOnCounter,
                hasToPrintOnAdditionalPrinter:
                  category.hasToPrintOnAdditionalPrinter,
                hasToAcceptReviews: category.hasToAcceptReviews,
                hasToEnableFlavorLimit: category.hasToEnableFlavorLimit,
                minimumFlavorLimit: category.minimumFlavorLimit,
                maximumFlavorLimit: category.maximumFlavorLimit,
              });
              const updateCategoriesProds = ref(
                db,
                `products/${t.selectedList.shopCode}/categories`
              );
              set(updateCategoriesProds, list.categories);
            }

            if (t.shouldShowWorkstations && category.selectedWorkstations && category.selectedWorkstations.length > 0) {
              try {
                await axios.post('/api/workstations/createWorkstationsCategories', {
                  categoryName: category.name,
                  shopCode: t.selectedList.shopCode,
                  workstations: category.selectedWorkstations
                });
              } catch (error) {
                console.error('Error al guardar las estaciones de trabajo:', error);
              }
            }
            t.closeModalById("#modalCategory");
            // Reset modal loading state after closing
            if (t.$refs.ModalCategory) {
              t.$refs.ModalCategory.resetLoadingState();
            }
            t.getCategories();
            t.clearCategory();
            toast.success(`La categoría ${nameInCamelCase} se creó exitosamente!`);
          }
        });

      } else {
        let dataShopsId = [];
        const currentValueProdsShop = ref(
          db,
          `products/${this.selectedList.shopCode}`
        );

        get(currentValueProdsShop).then((snapshot) => {
          var list = snapshot.val();

          if (!dataShopsId.includes(list?.idList)) {
            dataShopsId.push(list?.idList);

            if (
              t.isCategoryNameInFirebase(list, category, t, oldCategoryName)
            ) {
              return;
            }

            let cat = list.categories.filter((c) => c.name === oldCategoryName);
            // BPM-38: estado del límite ANTES de editar. Se toma de la categoría
            // y se usa también para sus productos (ellos no siempre lo tienen).
            let wasFlavorLimitEnabled = false;
            if (cat.length === 1) {
              wasFlavorLimitEnabled = cat[0].hasToEnableFlavorLimit ?? false;
              cat[0].name = category.name;
              cat[0].orderNumber = category.orderNumber || null;
              cat[0].hasToPrintInKitchen = category.hasToPrintInKitchen;
              cat[0].hasToPrintOnCounter = category.hasToPrintOnCounter;
              cat[0].hasToPrintOnAdditionalPrinter =
                category.hasToPrintOnAdditionalPrinter;
              cat[0].hasToAcceptReviews = category.hasToAcceptReviews;
              cat[0].hasToEnableFlavorLimit = category.hasToEnableFlavorLimit;
              cat[0].minimumFlavorLimit = category.minimumFlavorLimit;
              cat[0].maximumFlavorLimit = category.maximumFlavorLimit;
              t.updateOptionGroups(cat[0], wasFlavorLimitEnabled);
              const updateProductsCateg = ref(
                db,
                `products/${t.selectedList.shopCode}/categories`
              );
              set(updateProductsCateg, list.categories);
            }
            t.getCategories();
                // FIXME:: Edición del departamento en los productos

            const currentValueLP = ref(db, "listProducts/" + t.selectedList.id);
            
                  get(currentValueLP).then(async (snapshot) => {
                    const resp = snapshot.val();
                    if (resp != null) {
                      if (resp.products !== undefined && resp.products !== null) {
                        let allProds = Object.entries(resp.products);
                        allProds.forEach((element) => {
                          var key = element[0];
                          var prod = element[1];
                          if (prod.department === oldCategoryName) {                            
                            prod.department = category.name;
                            prod.hasToPrintInKitchen = category.hasToPrintInKitchen;
                            prod.hasToPrintOnCounter = category.hasToPrintOnCounter;
                            prod.hasToPrintOnAdditionalPrinter =
                              category.hasToPrintOnAdditionalPrinter;
                            prod.hasToEnableFlavorLimit =
                              category.hasToEnableFlavorLimit;
                            prod.minimumFlavorLimit = category.minimumFlavorLimit;
                            prod.maximumFlavorLimit = category.maximumFlavorLimit;
                            t.updateOptionGroups(prod, wasFlavorLimitEnabled);
                            const updateLP = ref(
                              db,
                              `listProducts/${t.selectedList.id}/products/${key}`
                            );
                            update(updateLP, prod);
                          }
                        });
                        
                      if (resp.combos) {
                        let allCombos = Object.entries(resp.combos);
                        allCombos.forEach((element) => {
                          var key = element[0];
                          var combo = element[1];

                          if (combo.department === oldCategoryName) {
                            combo.department = category.name;
                            const updateLPC = ref(
                              db,
                              `listProducts/${t.selectedList.id}/combos/${key}`
                            );
                            update(updateLPC, combo);
                          }
                        });
                      }

                      t.refreshProductList(t.selectedList);
                    }
                }

            // Update workstations for existing category after all Firebase updates
            if (t.shouldShowWorkstations && category.selectedWorkstations !== undefined && category.selectedWorkstations !== null) {
              try {
                const payload = {
                  categoryName: category.name,
                  shopCode: t.selectedList.shopCode,
                  workstations: category.selectedWorkstations
                };
                
                // Include original category name if category name is being edited
                if (oldCategoryName && oldCategoryName !== category.name) {
                  payload.originalCategoryName = oldCategoryName;
                }                
                await axios.post('/api/workstations/updateWorkstationsCategories', payload);
              } catch (error) {
                console.error('Error al actualizar las estaciones de trabajo:', error);
              }
            }

            t.categories = [...list.categories].sort((a, b) => a.name.localeCompare(b.name));
            t.closeModalById("#modalCategory");
            // Reset modal loading state after closing
            if (t.$refs.ModalCategory) {
              t.$refs.ModalCategory.resetLoadingState();
            }
            t.clearCategory();
            toast.success(`La categoría ${category.name} se guardó exitosamente!`);
            // Combinar nombre original y nuevo para validar sincronización
            const categoryNames = [...new Set([oldCategoryName, category.name].filter(Boolean))];
            t.shouldShowSyncMenuMessage(categoryNames);
            });
          }
        });
      }
      this.syncFoodDeliverySystemMenues(null, this.selectedList.shopCode);
      this.objectToRemove = null;
    },
    updateOptionGroups(prodOrCategory, wasFlavorLimitEnabled = false) {
      //Esta funcion sobreescribe lo que haya en minQty y maxQty de optionGroups y lo que haya en maxQty de la option dentro de un optionGroup
      // if( prodOrCategory.optionsGroups == null || prodOrCategory.optionsGroups == undefined )
      // 	return;

      // BPM-38: sin límite de gustos la categoría no le impone min/max a sus
      // grupos, así que no se pisan. Solo se reescriben si el límite está
      // activo o si se acaba de desactivar (para liberar el tope anterior).
      if (!(prodOrCategory.hasToEnableFlavorLimit ?? false) && !wasFlavorLimitEnabled) {
        return;
      }

      if (prodOrCategory.optionsGroups?.length > 0) {
        prodOrCategory.optionsGroups.forEach((optionGroup) => {
          //Se le setea tanto al optionGroup (gusto o adicional) la cantidad minima y maxima dependiendo de lo seteado en el limite de la categoria
          optionGroup.minQty = prodOrCategory.minimumFlavorLimit;
          optionGroup.maxQty = prodOrCategory.maximumFlavorLimit;
          //Le actualizo el valor maximo a cada opcion dentro de este optionGroup para que coincida con el valor maximo

          if (optionGroup.options?.length > 0) {
            optionGroup.options.forEach((option) => {
              option.minQty = Math.min(
                option.minQty ?? 0,
                prodOrCategory.hasToEnableFlavorLimit ?? false
                  ? prodOrCategory.maximumFlavorLimit
                  : option.maxQty
              );
              option.maxQty = prodOrCategory.maximumFlavorLimit;
            });
          }
        });
      }
    },
    filterProduct(t, filteredProds) {
      if (t.productSearchInput !== "") {
        filteredProds = filteredProds.filter((x) => {
          return (
            x[1].name
              ?.toUpperCase()
              ?.includes(t.productSearchInput.toUpperCase()) ||
            x[1]?.sku
              ?.toUpperCase()
              ?.includes(t.productSearchInput.toUpperCase())
          );
        });
      }
      if (
        t.productCategorySearchSelect !== "" &&
        t.productCategorySearchSelect !== "Todas las Categorías"
      ) {
        filteredProds = filteredProds.filter((x) => {
          return x[1].department
            .toUpperCase() === t.productCategorySearchSelect.toUpperCase(); /// Fixed: Now 'Bebidas' and 'Bebidas 2' filter correctly as separate categories.
        });
      }
      t.orderProductListByName(filteredProds);
      t.products = filteredProds;
    },
    filterCombos(t, filteredCombos) {
      if (t.combosSearchInput && t.combosSearchInput !== "") {
        filteredCombos = filteredCombos.filter((x) => {
          return (
            x[1]?.name
              ?.toUpperCase()
              ?.includes(t.combosSearchInput.toUpperCase()) ||
            x[1]?.sku
              ?.toUpperCase()
              ?.includes(t.combosSearchInput.toUpperCase())
          );
        });
      }

      let processedCombos = [];
      filteredCombos.forEach((x) => {
        if (x[1].sections !== undefined && x[1].sections !== null) {
          x[1].sections.forEach((y) => {
            if (y.products === undefined || y.products === null) {
              y.products = [];
            }
          });
        }

        processedCombos.push(x);
      });
      t.combosFromFirebase = JSON.parse(JSON.stringify(processedCombos));
      t.combos = processedCombos;
    },
    filterIngredient(t, originalIngredients) {
      let filteredIngredients = originalIngredients;

      if (t.ingredientSearchInput !== "") {
        filteredIngredients = originalIngredients.filter((x) => {
          return (
            x.name
              .toUpperCase()
              .includes(t.ingredientSearchInput.toUpperCase()) ||
            x.sku.toUpperCase().includes(t.ingredientSearchInput.toUpperCase())
          );
        });
      }
      t.filteredIngredients = filteredIngredients;;
    },
    getOptionsGroups() {
      const list = this.$store.getShopsThatHaveToShowAdvancedProducts;

      if (!list || list.length === 0) {
        this.optionGroups = [];
        return;
      }
      const foundShop = list.find(
        (shop) => Number(shop.shopCode) === Number(this.selectedList.shopCode)
      );

      this.optionGroups = foundShop ? foundShop.relatedOptionGroups || [] : [];
    },
    getOptions() {      
      // Crear un mapa para agrupar opciones por optionId y acumular los grupos
      const optionGroupsMap = new Map();
      
      this.optionGroups.forEach((group) => {
        (group.relatedOptions || []).forEach((option) => {
          if (!optionGroupsMap.has(option.optionId)) {
            optionGroupsMap.set(option.optionId, {
              ...option,
              optionGroups: [], // Lista de grupos donde aparece esta opción
              optionGroupIds: [] // Lista de IDs de grupos donde aparece esta opción
            });
          }
          // Agregar el grupo actual a la lista de grupos de esta opción
          optionGroupsMap.get(option.optionId).optionGroups.push(group.name);
          optionGroupsMap.get(option.optionId).optionGroupIds.push(group.optionGroupId);
        });
      });

      // Convertir el mapa a array de opciones únicas
      const uniqueOptions = Array.from(optionGroupsMap.values()).filter((option, index, array) => 
        array.findIndex(item => item.optionId === option.optionId) === index
      );

      this.optionsByGroup = uniqueOptions;
    },
    getIngredients(shopCode) {
      var params = {};
      if (this.hasCentralizedProducts)
        params["shopCode"] = this.getParentShopCode;
      else params["shopCode"] = shopCode;
      
      axios
        .get(`/api/ingredientsV2/?${parseToQuery(params)}`)
        .then((res) => {
          if (res.data.responseCode == 0) {
            this.ingredients = res.data.ingredients;
            this.ingredientsNoFilter = res.data.ingredients;
            
     
            if (this.ingredients !== undefined && this.ingredients !== null) {
              this.originalIngredients = JSON.parse(
                JSON.stringify(this.ingredients)
              );
              this.filterIngredient(this, this.originalIngredients);
            } else {
              this.ingredients = [];
            }
          } else {
            this.showErrors(res);
            this.ingredients = [];
          }
        })
        .catch((err) => {
          this.showErrors(err.response);
        });
    },
    refreshProductList(prodList, handler) {
      const t = this;
      let idList = null;
      if (prodList?.id === undefined) {
        idList = prodList?.idList;
      } else {
        idList = prodList?.id;
      }
      t.selectedList = t.productLists.find(
        (element) =>
          element.id === parseInt(idList) &&
          element.shopCode === prodList.shopCode
      );
      t.getCategories();

      if (handler === null || handler === undefined) {
        t.clearMenu();
      }
      t.clearCategory();
      t.clearOption();
      t.clearProduct();

      this.excelParams = parseToQuery({ listId: t.selectedList.id });
      this.excelAditionalParams = parseToQuery({
        shopCode: t.selectedList.shopCode,
      });
    
      // Usar caché para lista completa de productos
      const cacheKey = this.cacheKeys.LISTPRODUCTS(idList);
      
      let controlRefDatalistproducts = false;
      
      firebaseCache.get(cacheKey, async () => {
        const refDataListProducts = ref(db, "listProducts/" + idList);
        const snapshot = await get(refDataListProducts);
        return snapshot.val();
      }).then((resp) => {
        if (!controlRefDatalistproducts) {
          controlRefDatalistproducts = true;        
        if (resp != null) {
            //Proceso Productos. FIXME HZ:: Pasar a Metodo.
            if (resp.products !== undefined && resp.products !== null) {
              t.originalProducts = Object.entries(resp.products);
              this.filterProduct(t, t.originalProducts);
            } else {
              t.products = [];
            }

            //Proceso Menúes. FIXME HZ:: Pasar a Metodo.
            if (
              resp.menues !== undefined &&
              resp.menues !== null &&
              resp.menues.length > 0
            ) {
              t.menues = resp.menues;
            } else {
              t.menues = [];
            }
            //Proceso Origins. FIXME HZ:: Pasar a Metodo.
            if (
              resp.origins !== undefined &&
              resp.origins !== null &&
              resp.origins.length > 0
            ) {
              t.origins = resp.origins;
            } else {
              t.origins = [];
            }

            //Proceso Combos?. FIXME HZ:: Pasar a Metodo.
            if (resp.combos !== undefined && resp.combos !== null) {
              t.originalCombos = Object.entries(resp.combos);
              this.filterCombos(t, t.originalCombos);
            } else {
              t.combosFromFirebase = JSON.parse(JSON.stringify([]));
              t.combos = [];
            }
          } else {
            t.products = [];
            t.menues = [];
            t.origins = [];

            t.combosFromFirebase = JSON.parse(JSON.stringify([]));
            t.combos = [];
          }
          if (handler !== null && handler !== undefined) {
            handler();
          }
        } //controlRefDatalistproducts
      })
    },
    orderProductListByName(products) {
      products.sort(function (a, b) {
        if (!a[1].name) {
          return true;
        } else if (!b[1].name) {
          return false;
        } else
          return a[1].name
            .toLowerCase()
            .localeCompare(b[1].name.toLowerCase(), "es", {
              sensitivity: "base",
            });
      });
    },
    orderIngredientListByName(ingredients) {
      ingredients.sort(function (a, b) {
        if (!a[1].name) {
          return true;
        } else if (!b[1].name) {
          return false;
        } else
          return a[1].name
            .toLowerCase()
            .localeCompare(b[1].name.toLowerCase(), "es", {
              sensitivity: "base",
            });
      });
    },
    async exportProductList(listId) {
      this.excelParams = parseToQuery({ listId: listId });
      let url = "/api/productsV2/exportProducts";
      if (this.isEnergyPOSInstance) {
        url = "/api/productsV2/exportProductsEnergyPOS";
      }
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(`${url}/?${this.excelParams}`, "_blank");
        win.focus();
      }
    },
    async exportProductCostList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportProductCosts/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportProductRecipeList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportProductRecipes/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportAdditionalRecipeList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportAdditionalRecipes/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportIngredientRecipeList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportIngredientRecipes/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportAdditionalCostList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportAdditionalCosts/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportIngredientCostList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportIngredientCosts/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportIngredientList(shopCode) {
      this.excelParams = parseToQuery({ shopCode: shopCode });
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportIngredients/?${this.excelParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    async exportAditionalsList() {
      if (await this.checkSessionInBackendAsync()) {
        let win = window.open(
          `/api/productsV2/exportAditionals/?${this.excelAditionalParams}`,
          "_blank"
        );
        win.focus();
      }
    },
    openNewModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearProduct();
      this.isNewProduct = true;
      if (this.hasToShowAdvancedProducts)
        this.openModalById("#modalProductAdvanced");
      else this.openModalById("#modalProduct");
    },
    openNewOptionModal(optionType) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.clearOption();
      this.isNewOption = true;
      this.optionType = optionType;
      this.openModalById("#modalOption");
    },
    openNewOptionGroupModal(optionType) {
      if (!this.selectedList) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearOption();
      this.isNewOption = true;
      this.$nextTick(() => {
        this.optionType = optionType;
      });
      this.openNonDismissibleModal("#modalOptionGroup");
    },
    openEditOptionGroupModal(optionType) {
      if (!this.selectedList) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.clearOption();
      this.$nextTick(() => {
        this.optionType = optionType;
      });

      this.openNonDismissibleModal("#modalOptionGroup");
    },
    openNewAdvancedOptionModal(optionType, isNewOption) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      // Solo limpiar la opción si es una nueva opción
      // Si es una opción existente, mantener los datos para preselección
      if (isNewOption) {
        this.clearOption();
      }
      
      this.isNewOption = isNewOption;
      this.optionType = optionType;
      this.openModalById("#modalAdvancedOptions");
    },
    openNewMenuModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearMenu();

      this.originsForUse = this.getAvailableOriginsForMenu();

      let origins = [];
      this.getProductsByMenu(origins, (x) => {
        this.openModalById("#modalMenu");
      });
      this.isNewMenu = true;
      this.currentMenu = "";

      // this.openModalById('#modalMenu')
    },
    openMenuModal(menu, index) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearMenu();

      this.originsForUse = this.getAvailableOriginsForMenu();

      this.menu = {
        name: menu.name,
        key: index,
        origins: menu.origins,
        uuid: menu.uuid,
      };
      this.currentMenu = menu.name;
      this.isNewMenu = false;
      this.objectToRemove = { object: this.menu, index: index, type: "Carta" };

      this.getProductsByMenu(menu.origins, (x) => {
        if (this.currentMenu) {
          this.openModalById("#modalMenu");
        }
      });

      // this.openModalById('#modalMenu')
    },
    openCategoryModal(category) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearCategory();
      let clone = Object.assign(category, {});
      this.category = Object.assign(this.category, clone);
      this.oldCategoryName = category.name;
      this.objectToRemove = {
        object: this.category,
        index: null,
        type: "Categoría",
      };

      this.openModalById("#modalCategory");
    },
    getAvailableOriginsForMenu() {
      let originsInUse = [];
      let originsForUse = [];
      if (
        this.menues !== undefined &&
        this.menues !== null &&
        this.menues.length > 0
      ) {
        this.menues.forEach((menu) => {
          menu.origins.forEach((origin) => {
            originsInUse.push(origin);
          });
        });
      }

      this.originsNodo.forEach((o) => {
        if (
          originsInUse.filter((t) => t.name === o.name).length === 0 && // Validación original
          (!this.isEnergyPOSInstance || // Condición adicional para energypos
            (o.name !== "Pedidos Ya" &&
              o.name !== "Rappi" &&
              o.name !== "Rappi Turbo" &&
              o.name !== "Weborders"))
        ) {
          originsForUse.push(o);
        }
      });
      return originsForUse;
    },

    openNewComboModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearCombo();
      this.isNewCombo = true;
      let origins = [];
      this.getProductsByMenu(origins, (x) => {});
      this.openModalById("#modalCombo");
    },
    openNewIngredientModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearIngredient();
      this.isNewIngredient = true;
      this.openModalById("#modalIngredient");
    },
    onCloseIngredientModal() {
      this.clearIngredient();
      this.closeModalById("#modalIngredient");
      this.getIngredients(this.selectedList.shopCode);
      ///FIXME HZ
    },
    openNewCategoryModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.clearCategory();
      this.isNewCategory = true;

      this.openModalById("#modalCategory");
    },
    openOptionModal(option, optionType) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.clearOption();
      this.optionType = optionType;
      let clone = Object.assign(option, {});
      this.option = Object.assign(this.option, clone);
      this.option.price = this.getParse(this.option.price, "justNumber", "."); ///OK ADV HZ

      this.calculateInitialCheckCategories(option);
      
      // Agregar las categorías al objeto option
      this.option.categories = [...this.checkedCategories];

      this.objectToRemove = {
        object: this.option,
        index: null,
        type: optionType,
      };

      this.openModalById("#modalOption");
    },
    calculateInitialCheckCategories(option) {
      this.categories.forEach((element) => {
        if (
          element.optionsGroups !== undefined &&
          element.optionsGroups.length > 0
        ) {
          let og = element.optionsGroups.filter(
            (t) => t.name === this.getOptionType()
          );
          if (og !== undefined && og.length > 0) {
            let o = og[0].options.filter(
              (t) => t.name === option.name && t.price === option.price
            );
            if (o !== undefined && o.length > 0) {
              this.checkedCategories.push(element.name);
              this.initialCheckedCategories.push(element.name);
            }
          }
        }
      });
    },
    openImportModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportProduct.clearFile();
      this.$refs.modalImportProduct.setShopCode(this.getSelectedShop);

      var modalInstance = document.getElementById("ModalImportProducts");
      var instance = M.Modal.init(modalInstance);
      instance.open();

      //$("#ModalImportProducts").modal("open");
    },
    openImportProductCostModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportCost.clearFile();
      this.$refs.modalImportCost.setShopCode(this.getSelectedShop);
      this.$refs.modalImportCost.setCostType("Product");
      this.openModalById("#ModalImportCosts");
    },
    openImportProductRecipeModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportRecipe.clearFile();
      this.$refs.modalImportRecipe.setShopCode(this.getSelectedShop);
      this.$refs.modalImportRecipe.setCostType("Product");
      this.openModalById("#ModalImportRecipes");
    },
    openImportAdditionalCostModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportCost.clearFile();
      this.$refs.modalImportCost.setShopCode(this.getSelectedShop);
      this.$refs.modalImportCost.setCostType("Additional");
      this.openModalById("#ModalImportCosts");
    },
    openImportAdditionalRecipeModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportRecipe.clearFile();
      this.$refs.modalImportRecipe.setShopCode(this.getSelectedShop);
      this.$refs.modalImportRecipe.setCostType("Additional");
      this.openModalById("#ModalImportRecipes");
    },
    openImportIngredientCostModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportCost.clearFile();
      this.$refs.modalImportCost.setShopCode(this.getSelectedShop);
      this.$refs.modalImportCost.setCostType("Ingredient");
      this.openModalById("#ModalImportCosts");
    },
    openImportIngredientRecipeModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalImportRecipe.clearFile();
      this.$refs.modalImportRecipe.setShopCode(this.getSelectedShop);
      this.$refs.modalImportRecipe.setCostType("Ingredient");
      this.openModalById("#ModalImportRecipes");
    },
    openImportIngredientModal() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.$refs.modalImportIngredient.clearFile();
      this.$refs.modalImportIngredient.setShopCode(this.getSelectedShop);

      var modalInstance = document.getElementById("ModalImportIngredients");
      var instance = M.Modal.init(modalInstance);
      instance.open();
      //$("#ModalImportIngredients").modal("open");
    },
    recoveryProductListFromBackup() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalRecoveryProductsFromBackup.setShopCode(
        this.getSelectedShop
      );
      const params = parseToQuery({ shopCode: this.getSelectedShop });
      axios
        .get(`/api/productsV2/getProductBackups/?${params}`)
        .then((resp) => {
          this.availableBackups = resp.data.backups;
          var modalInstance = document.getElementById(
            "ModalRecoveryProductsFromBackup"
          );
          var instance = M.Modal.init(modalInstance);
          instance.open();

          //$("#ModalRecoveryProductsFromBackup").modal("open");
        })
        .catch((err) => {
          console.error(err.response);

          var modalInstance = document.getElementById(
            "ModalRecoveryProductsFromBackup"
          );
          var instance = M.Modal.init(modalInstance);
          instance.open();

          //$("#ModalRecoveryProductsFromBackup").modal("open");
        });
    },
    recoveryProductCostListFromBackup() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.$refs.modalRecoveryProductCostsFromBackup.setShopCode(
        this.getSelectedShop
      );
      const params = parseToQuery({ shopCode: this.getSelectedShop });
      axios
        .get(`/api/productsV2/getProductCostBackups/?${params}`)
        .then((resp) => {
          this.availableBackups = resp.data.backups;

          this.openModalById("#ModalRecoveryProductCostsFromBackup");
        })
        .catch((err) => {
          console.error(err.response);
          this.openModalById("#ModalRecoveryProductCostsFromBackup");
        });
    },
    recoveryAdditionalCostListFromBackup() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.$refs.modalRecoveryAdditionalCostsFromBackup.setShopCode(
        this.getSelectedShop
      );
      const params = parseToQuery({ shopCode: this.getSelectedShop });
      axios
        .get(`/api/productsV2/getAdditionalCostBackups/?${params}`)
        .then((resp) => {
          this.availableBackups = resp.data.backups;
          this.openModalById("#ModalRecoveryAdditionalCostsFromBackup");
        })
        .catch((err) => {
          console.error(err.response);
          this.openModalById("#ModalRecoveryAdditionalCostsFromBackup");
        });
    },
    recoveryIngredientCostListFromBackup() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      this.$refs.modalRecoveryIngredientCostsFromBackup.setShopCode(
        this.getSelectedShop
      );
      const params = parseToQuery({ shopCode: this.getSelectedShop });
      axios
        .get(`/api/productsV2/getIngredientCostBackups/?${params}`)
        .then((resp) => {
          this.availableBackups = resp.data.backups;
          this.openModalById("#ModalRecoveryIngredientCostsFromBackup");
        })
        .catch((err) => {
          console.error(err.response);
          this.openModalById("#ModalRecoveryIngredientCostsFromBackup");
        });
    },
    recoveryIngredientsListFromBackup() {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.$refs.modalRecoveryIngredientsFromBackup.setShopCode(
        this.getSelectedShop
      );
      const params = parseToQuery({ shopCode: this.getSelectedShop });
      axios
        .get(`/api/productsV2/getIngredientsBackups/?${params}`)
        .then((resp) => {
          this.availableBackups = resp.data.backups;

          var modalInstance = document.getElementById(
            "ModalRecoveryIngredientsFromBackup"
          );
          var instance = M.Modal.init(modalInstance);
          instance.open();

          //$("#ModalRecoveryIngredientsFromBackup").modal("open");
        })
        .catch((err) => {
          console.error(err.response);

          var modalInstance = document.getElementById(
            "ModalRecoveryIngredientsFromBackup"
          );
          var instance = M.Modal.init(modalInstance);
          instance.open();

          //$("#ModalRecoveryIngredientsFromBackup").modal("open");
        });
    },
    openImportAditionalsModal(optionType) {
      this.additionalOptionType = optionType;

      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }

      var modal = document.getElementById("ModalImportAditionals");
      var instance = M.Modal.init(modal);
      instance.open();
    },
    handleModal(product, key) {
      this.clearProduct();

      this.currentProduct = {
        sku: product.sku,
        name: product.name,
        department: product.department,
        rootVat: product.rootVat,
      };
      this.isNewProduct = false;
      this.deletingProduct = false;
      this.currentProductKey = key;
      let clone = Object.assign(product, {});
      this.product = Object.assign(this.product, clone);

      this.objectToRemove = {
        object: this.product,
        index: key,
        type: "Producto",
      };
      if (this.hasToShowAdvancedProducts)
        this.openModalById("#modalProductAdvanced");
      else this.openModalById("#modalProduct");
    },
    handleComboModal(combo, key) {
      this.clearCombo();
      this.currentCombo = {
        sku: combo.sku,
        name: combo.name,
        department: combo.department,
      };
      this.isNewCombo = false;
      this.deletingCombo = false;
      let comboFound = false;
      this.combosFromFirebase.forEach((x) => {
        if (combo.sku === x[1].sku) {
          this.combo = JSON.parse(JSON.stringify(x[1]));
          comboFound = true;
        }
      });
      this.currentComboKey = key;
      if (comboFound === false) {
        let clone = Object.assign(combo, {});
        this.combo = Object.assign(this.combo, clone);
      }

      let origins = [];
      this.getProductsByMenu(origins, (x) => {});
      this.objectToRemove = { object: this.combo, index: key, type: "Combo" };
      this.openModalById("#modalCombo");
    },
    handleIngredientModal(item) {
      if (this.selectedList === null || this.selectedList === undefined) {
        toast.error("Por favor elija una lista de productos primero");
        return;
      }
      this.clearIngredient();
      this.isNewIngredient = false;

      let clone = Object.assign(item, {});
      this.ingredient = Object.assign(this.ingredient, clone);
      this.objectToRemove = {
        object: this.ingredient,
        index: this.ingredient.id,
        type: "Ingrediente",
      };
      this.openModalById("#modalIngredient");
    },
    clearProduct() {
      this.product = {
        department: "",
        description: "",
        image: "",
        name: "",
        sku: "",
        optionsGroup: [],
        origins: [],
        shortName: "",
        // stock: 0,
        weightable: false,
        measureUnit: "",
        minimunStockQuantity: 0,
        type: "",
        rootVat: "",
      };
      this.currentProductKey = -1;
      this.currentProduct = null;
    },
    clearCombo() {
      this.combo = {
        department: "",
        description: "",
        image: "",
        name: "",
        sku: "",
        rootVat: "",
      };
      this.currentComboKey = -1;
      this.currentCombo = null;
    },
    clearIngredient() {
      this.ingredient = {
        id: 0,
        name: "",
        sku: "",
        description: "",
        cost: 0,
        weightable: true,
        measureUnit: "",
        minimunStockQuantity: 0,
        ullagePercentage: 0,
      };
      this.isNewIngredient = false;
    },
    clearOption() {
      this.option = {
        maxQty: 0,
        minQty: 0,
        name: "",
        price: "",
        exempt: false,
        nonTaxed: false,
      };
      this.isNewOption = false;
      this.optionType = "";
      this.checkedCategories = [];
      this.initialCheckedCategories = [];
    },
    clearMenu() {
      this.menu = {
        key: "",
        name: "",
        origins: [],
      };
      this.originsForUse = [];
      this.productsByMenu = [];
      this.isNewMenu = false;
    },
    clearCategory() {
      this.category = {
        name: "",
        optionsGroups: [],
      };
      this.isNewCategory = false;
      this.oldCategoryName = "";
    },
    enableSpinnerOnMenu() {
      this.isMenuLoading = true;
    },
    disableSpinnerOnMenu() {
      this.isMenuLoading = false;
    },
    async getCategoriesFromRelatedOptions(relatedOptions) {
      if (!relatedOptions?.length) {
        return [];
      }
      
      const categories = new Set(); // Usar Set para evitar duplicados

      for (const relatedOption of relatedOptions) {
        try {
          const optionData = await this.getOneOption(relatedOption.optionId, this.selectedList.shopCode);
          if (optionData?.enabledCategories?.length) {
            optionData.enabledCategories.forEach(category => {
              categories.add(category);
            });
          }
        } catch (error) {
          console.error(`Error al obtener datos de la opción ${relatedOption.optionId}:`, error);
        }
      }
      
      return Array.from(categories);
    },
  },
  /* eslint-enable */
};
</script>
